window.jQuery || function (e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function (e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
        : t(e)
}("undefined" != typeof window ? window : this, function (h, e) {
    function t(e, t) {
        return t.toUpperCase()
    }
    var d = []
        , u = d.slice
        , m = d.concat
        , s = d.push
        , i = d.indexOf
        , n = {}
        , o = n.toString
        , y = n.hasOwnProperty
        , r = "".trim
        , g = {}
        , a = "1.11.0"
        , w = function (e, t) {
            return new w.fn.init(e, t)
        }
        , l = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
        , c = /^-ms-/
        , p = /-([\da-z])/gi;
    function f(e) {
        var t = e.length
            , n = w.type(e);
        return "function" !== n && !w.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e))
    }
    w.fn = w.prototype = {
        jquery: a,
        constructor: w,
        selector: "",
        length: 0,
        toArray: function () {
            return u.call(this)
        },
        get: function (e) {
            return null != e ? e < 0 ? this[e + this.length] : this[e] : u.call(this)
        },
        pushStack: function (e) {
            e = w.merge(this.constructor(), e);
            return e.prevObject = this,
                e.context = this.context,
                e
        },
        each: function (e, t) {
            return w.each(this, e, t)
        },
        map: function (n) {
            return this.pushStack(w.map(this, function (e, t) {
                return n.call(e, t, e)
            }))
        },
        slice: function () {
            return this.pushStack(u.apply(this, arguments))
        },
        first: function () {
            return this.eq(0)
        },
        last: function () {
            return this.eq(-1)
        },
        eq: function (e) {
            var t = this.length
                , e = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= e && e < t ? [this[e]] : [])
        },
        end: function () {
            return this.prevObject || this.constructor(null)
        },
        push: s,
        sort: d.sort,
        splice: d.splice
    },
        w.extend = w.fn.extend = function () {
            var e, t, n, o, i, r = arguments[0] || {}, a = 1, s = arguments.length, l = !1;
            for ("boolean" == typeof r && (l = r,
                r = arguments[a] || {},
                a++),
                "object" == typeof r || w.isFunction(r) || (r = {}),
                a === s && (r = this,
                    a--); a < s; a++)
                if (null != (o = arguments[a]))
                    for (n in o)
                        i = r[n],
                            t = o[n],
                            r !== t && (l && t && (w.isPlainObject(t) || (e = w.isArray(t))) ? (i = e ? (e = !1,
                                i && w.isArray(i) ? i : []) : i && w.isPlainObject(i) ? i : {},
                                r[n] = w.extend(l, i, t)) : void 0 !== t && (r[n] = t));
            return r
        }
        ,
        w.extend({
            expando: "jQuery" + (a + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e)
            },
            noop: function () { },
            isFunction: function (e) {
                return "function" === w.type(e)
            },
            isArray: Array.isArray || function (e) {
                return "array" === w.type(e)
            }
            ,
            isWindow: function (e) {
                return null != e && e == e.window
            },
            isNumeric: function (e) {
                return 0 <= e - parseFloat(e)
            },
            isEmptyObject: function (e) {
                for (var t in e)
                    return !1;
                return !0
            },
            isPlainObject: function (e) {
                if (!e || "object" !== w.type(e) || e.nodeType || w.isWindow(e))
                    return !1;
                try {
                    if (e.constructor && !y.call(e, "constructor") && !y.call(e.constructor.prototype, "isPrototypeOf"))
                        return !1
                } catch (e) {
                    return !1
                }
                if (g.ownLast)
                    for (var t in e)
                        return y.call(e, t);
                for (t in e)
                    ;
                return void 0 === t || y.call(e, t)
            },
            type: function (e) {
                return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? n[o.call(e)] || "object" : typeof e
            },
            globalEval: function (e) {
                e && w.trim(e) && (h.execScript || function (e) {
                    h.eval.call(h, e)
                }
                )(e)
            },
            camelCase: function (e) {
                return e.replace(c, "ms-").replace(p, t)
            },
            nodeName: function (e, t) {
                return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
            },
            each: function (e, t, n) {
                var o, i = 0, r = e.length, a = f(e);
                if (n) {
                    if (a)
                        for (; i < r && !1 !== (o = t.apply(e[i], n)); i++)
                            ;
                    else
                        for (i in e)
                            if (o = t.apply(e[i], n),
                                !1 === o)
                                break
                } else if (a)
                    for (; i < r && !1 !== (o = t.call(e[i], i, e[i])); i++)
                        ;
                else
                    for (i in e)
                        if (o = t.call(e[i], i, e[i]),
                            !1 === o)
                            break;
                return e
            },
            trim: r && !r.call("\ufeff ") ? function (e) {
                return null == e ? "" : r.call(e)
            }
                : function (e) {
                    return null == e ? "" : (e + "").replace(l, "")
                }
            ,
            makeArray: function (e, t) {
                t = t || [];
                return null != e && (f(Object(e)) ? w.merge(t, "string" == typeof e ? [e] : e) : s.call(t, e)),
                    t
            },
            inArray: function (e, t, n) {
                var o;
                if (t) {
                    if (i)
                        return i.call(t, e, n);
                    for (o = t.length,
                        n = n ? n < 0 ? Math.max(0, o + n) : n : 0; n < o; n++)
                        if (n in t && t[n] === e)
                            return n
                }
                return -1
            },
            merge: function (e, t) {
                for (var n = +t.length, o = 0, i = e.length; o < n;)
                    e[i++] = t[o++];
                if (n != n)
                    for (; void 0 !== t[o];)
                        e[i++] = t[o++];
                return e.length = i,
                    e
            },
            grep: function (e, t, n) {
                for (var o = [], i = 0, r = e.length, a = !n; i < r; i++)
                    !t(e[i], i) != a && o.push(e[i]);
                return o
            },
            map: function (e, t, n) {
                var o, i = 0, r = e.length, a = [];
                if (f(e))
                    for (; i < r; i++)
                        null != (o = t(e[i], i, n)) && a.push(o);
                else
                    for (i in e)
                        o = t(e[i], i, n),
                            null != o && a.push(o);
                return m.apply([], a)
            },
            guid: 1,
            proxy: function (e, t) {
                var n, o;
                return "string" == typeof t && (o = e[t],
                    t = e,
                    e = o),
                    w.isFunction(e) ? (n = u.call(arguments, 2),
                        (o = function () {
                            return e.apply(t || this, n.concat(u.call(arguments)))
                        }
                        ).guid = e.guid = e.guid || w.guid++,
                        o) : void 0
            },
            now: function () {
                return +new Date
            },
            support: g
        }),
        w.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
            n["[object " + t + "]"] = t.toLowerCase()
        });
    var v = function (n) {
        var e, f, x, r, t, h, w, c, u, m, k, o, y, g, i, a, v, b = "sizzle" + -new Date, T = n.document, C = 0, d = 0, s = ne(), p = ne(), l = ne(), _ = function (e, t) {
            return e === t && (u = !0),
                0
        }, j = "undefined", N = {}.hasOwnProperty, E = [], S = E.pop, A = E.push, z = E.push, D = E.slice, L = E.indexOf || function (e) {
            for (var t = 0, n = this.length; t < n; t++)
                if (this[t] === e)
                    return t;
            return -1
        }
            , H = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", q = "[\\x20\\t\\r\\n\\f]", F = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", M = F.replace("w", "w#"), O = "\\[" + q + "*(" + F + ")" + q + "*(?:([*^$|!~]?=)" + q + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + M + ")|)|)" + q + "*\\]", B = ":(" + F + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + O.replace(3, 8) + ")*)|.*)\\)|)", Q = new RegExp("^" + q + "+|((?:^|[^\\\\])(?:\\\\.)*)" + q + "+$", "g"), P = new RegExp("^" + q + "*," + q + "*"), W = new RegExp("^" + q + "*([>+~]|" + q + ")" + q + "*"), R = new RegExp("=" + q + "*([^\\]'\"]*?)" + q + "*\\]", "g"), $ = new RegExp(B), I = new RegExp("^" + M + "$"), X = {
                ID: new RegExp("^#(" + F + ")"),
                CLASS: new RegExp("^\\.(" + F + ")"),
                TAG: new RegExp("^(" + F.replace("w", "w*") + ")"),
                ATTR: new RegExp("^" + O),
                PSEUDO: new RegExp("^" + B),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + q + "*(even|odd|(([+-]|)(\\d*)n|)" + q + "*(?:([+-]|)" + q + "*(\\d+)|))" + q + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + H + ")$", "i"),
                needsContext: new RegExp("^" + q + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + q + "*((?:-\\d)?\\d*)" + q + "*\\)|)(?=[^-]|$)", "i")
            }, V = /^(?:input|select|textarea|button)$/i, U = /^h\d$/i, Z = /^[^{]+\{\s*\[native \w/, J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Y = /[+~]/, G = /'|\\/g, K = new RegExp("\\\\([\\da-f]{1,6}" + q + "?|(" + q + ")|.)", "ig"), ee = function (e, t, n) {
                var o = "0x" + t - 65536;
                return o != o || n ? t : o < 0 ? String.fromCharCode(65536 + o) : String.fromCharCode(o >> 10 | 55296, 1023 & o | 56320)
            };
        try {
            z.apply(E = D.call(T.childNodes), T.childNodes),
                E[T.childNodes.length].nodeType
        } catch (e) {
            z = {
                apply: E.length ? function (e, t) {
                    A.apply(e, D.call(t))
                }
                    : function (e, t) {
                        for (var n = e.length, o = 0; e[n++] = t[o++];)
                            ;
                        e.length = n - 1
                    }
            }
        }
        function te(e, t, n, o) {
            var i, r, a, s, l, c, u, d, p;
            if ((t ? t.ownerDocument || t : T) !== k && m(t),
                n = n || [],
                !e || "string" != typeof e)
                return n;
            if (1 !== (a = (t = t || k).nodeType) && 9 !== a)
                return [];
            if (y && !o) {
                if (i = J.exec(e))
                    if (c = i[1]) {
                        if (9 === a) {
                            if (!(r = t.getElementById(c)) || !r.parentNode)
                                return n;
                            if (r.id === c)
                                return n.push(r),
                                    n
                        } else if (t.ownerDocument && (r = t.ownerDocument.getElementById(c)) && v(t, r) && r.id === c)
                            return n.push(r),
                                n
                    } else {
                        if (i[2])
                            return z.apply(n, t.getElementsByTagName(e)),
                                n;
                        if ((c = i[3]) && f.getElementsByClassName && t.getElementsByClassName)
                            return z.apply(n, t.getElementsByClassName(c)),
                                n
                    }
                if (f.qsa && (!g || !g.test(e))) {
                    if (u = c = b,
                        d = t,
                        p = 9 === a && e,
                        1 === a && "object" !== t.nodeName.toLowerCase()) {
                        for (l = ue(e),
                            (c = t.getAttribute("id")) ? u = c.replace(G, "\\$&") : t.setAttribute("id", u),
                            u = "[id='" + u + "'] ",
                            s = l.length; s--;)
                            l[s] = u + de(l[s]);
                        d = Y.test(e) && le(t.parentNode) || t,
                            p = l.join(",")
                    }
                    if (p)
                        try {
                            return z.apply(n, d.querySelectorAll(p)),
                                n
                        } catch (e) { } finally {
                            c || t.removeAttribute("id")
                        }
                }
            }
            return function (e, t, n, o) {
                var i, r, a, s, l, c = ue(e);
                if (!o && 1 === c.length) {
                    if (2 < (r = c[0] = c[0].slice(0)).length && "ID" === (a = r[0]).type && f.getById && 9 === t.nodeType && y && x.relative[r[1].type]) {
                        if (!(t = (x.find.ID(a.matches[0].replace(K, ee), t) || [])[0]))
                            return n;
                        e = e.slice(r.shift().value.length)
                    }
                    for (i = X.needsContext.test(e) ? 0 : r.length; i-- && (a = r[i],
                        !x.relative[s = a.type]);)
                        if ((l = x.find[s]) && (o = l(a.matches[0].replace(K, ee), Y.test(r[0].type) && le(t.parentNode) || t))) {
                            if (r.splice(i, 1),
                                !(e = o.length && de(r)))
                                return z.apply(n, o),
                                    n;
                            break
                        }
                }
                return h(e, c)(o, t, !y, n, Y.test(e) && le(t.parentNode) || t),
                    n
            }(e.replace(Q, "$1"), t, n, o)
        }
        function ne() {
            var n = [];
            function o(e, t) {
                return n.push(e + " ") > x.cacheLength && delete o[n.shift()],
                    o[e + " "] = t
            }
            return o
        }
        function oe(e) {
            return e[b] = !0,
                e
        }
        function ie(e) {
            var t = k.createElement("div");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                    t = null
            }
        }
        function re(e, t) {
            for (var n = e.split("|"), o = e.length; o--;)
                x.attrHandle[n[o]] = t
        }
        function ae(e, t) {
            var n = t && e
                , o = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || 1 << 31) - (~e.sourceIndex || 1 << 31);
            if (o)
                return o;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === t)
                        return -1;
            return e ? 1 : -1
        }
        function se(a) {
            return oe(function (r) {
                return r = +r,
                    oe(function (e, t) {
                        for (var n, o = a([], e.length, r), i = o.length; i--;)
                            e[n = o[i]] && (e[n] = !(t[n] = e[n]))
                    })
            })
        }
        function le(e) {
            return e && typeof e.getElementsByTagName !== j && e
        }
        for (e in f = te.support = {},
            t = te.isXML = function (e) {
                e = e && (e.ownerDocument || e).documentElement;
                return !!e && "HTML" !== e.nodeName
            }
            ,
            m = te.setDocument = function (e) {
                var l = e ? e.ownerDocument || e : T
                    , e = l.defaultView;
                return l !== k && 9 === l.nodeType && l.documentElement ? (o = (k = l).documentElement,
                    y = !t(l),
                    e && e !== e.top && (e.addEventListener ? e.addEventListener("unload", function () {
                        m()
                    }, !1) : e.attachEvent && e.attachEvent("onunload", function () {
                        m()
                    })),
                    f.attributes = ie(function (e) {
                        return e.className = "i",
                            !e.getAttribute("className")
                    }),
                    f.getElementsByTagName = ie(function (e) {
                        return e.appendChild(l.createComment("")),
                            !e.getElementsByTagName("*").length
                    }),
                    f.getElementsByClassName = Z.test(l.getElementsByClassName) && ie(function (e) {
                        return e.innerHTML = "<div class='a'></div><div class='a i'></div>",
                            e.firstChild.className = "i",
                            2 === e.getElementsByClassName("i").length
                    }),
                    f.getById = ie(function (e) {
                        return o.appendChild(e).id = b,
                            !l.getElementsByName || !l.getElementsByName(b).length
                    }),
                    f.getById ? (x.find.ID = function (e, t) {
                        if (typeof t.getElementById !== j && y) {
                            e = t.getElementById(e);
                            return e && e.parentNode ? [e] : []
                        }
                    }
                        ,
                        x.filter.ID = function (e) {
                            var t = e.replace(K, ee);
                            return function (e) {
                                return e.getAttribute("id") === t
                            }
                        }
                    ) : (delete x.find.ID,
                        x.filter.ID = function (e) {
                            var t = e.replace(K, ee);
                            return function (e) {
                                e = typeof e.getAttributeNode !== j && e.getAttributeNode("id");
                                return e && e.value === t
                            }
                        }
                    ),
                    x.find.TAG = f.getElementsByTagName ? function (e, t) {
                        return typeof t.getElementsByTagName !== j ? t.getElementsByTagName(e) : void 0
                    }
                        : function (e, t) {
                            var n, o = [], i = 0, r = t.getElementsByTagName(e);
                            if ("*" !== e)
                                return r;
                            for (; n = r[i++];)
                                1 === n.nodeType && o.push(n);
                            return o
                        }
                    ,
                    x.find.CLASS = f.getElementsByClassName && function (e, t) {
                        return typeof t.getElementsByClassName !== j && y ? t.getElementsByClassName(e) : void 0
                    }
                    ,
                    i = [],
                    g = [],
                    (f.qsa = Z.test(l.querySelectorAll)) && (ie(function (e) {
                        e.innerHTML = "<select t=''><option selected=''></option></select>",
                            e.querySelectorAll("[t^='']").length && g.push("[*^$]=" + q + "*(?:''|\"\")"),
                            e.querySelectorAll("[selected]").length || g.push("\\[" + q + "*(?:value|" + H + ")"),
                            e.querySelectorAll(":checked").length || g.push(":checked")
                    }),
                        ie(function (e) {
                            var t = l.createElement("input");
                            t.setAttribute("type", "hidden"),
                                e.appendChild(t).setAttribute("name", "D"),
                                e.querySelectorAll("[name=d]").length && g.push("name" + q + "*[*^$|!~]?="),
                                e.querySelectorAll(":enabled").length || g.push(":enabled", ":disabled"),
                                e.querySelectorAll("*,:x"),
                                g.push(",.*:")
                        })),
                    (f.matchesSelector = Z.test(a = o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ie(function (e) {
                        f.disconnectedMatch = a.call(e, "div"),
                            a.call(e, "[s!='']:x"),
                            i.push("!=", B)
                    }),
                    g = g.length && new RegExp(g.join("|")),
                    i = i.length && new RegExp(i.join("|")),
                    e = Z.test(o.compareDocumentPosition),
                    v = e || Z.test(o.contains) ? function (e, t) {
                        var n = 9 === e.nodeType ? e.documentElement : e
                            , t = t && t.parentNode;
                        return e === t || !(!t || 1 !== t.nodeType || !(n.contains ? n.contains(t) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(t)))
                    }
                        : function (e, t) {
                            if (t)
                                for (; t = t.parentNode;)
                                    if (t === e)
                                        return !0;
                            return !1
                        }
                    ,
                    _ = e ? function (e, t) {
                        if (e === t)
                            return u = !0,
                                0;
                        var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                        return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !f.sortDetached && t.compareDocumentPosition(e) === n ? e === l || e.ownerDocument === T && v(T, e) ? -1 : t === l || t.ownerDocument === T && v(T, t) ? 1 : c ? L.call(c, e) - L.call(c, t) : 0 : 4 & n ? -1 : 1)
                    }
                        : function (e, t) {
                            if (e === t)
                                return u = !0,
                                    0;
                            var n, o = 0, i = e.parentNode, r = t.parentNode, a = [e], s = [t];
                            if (!i || !r)
                                return e === l ? -1 : t === l ? 1 : i ? -1 : r ? 1 : c ? L.call(c, e) - L.call(c, t) : 0;
                            if (i === r)
                                return ae(e, t);
                            for (n = e; n = n.parentNode;)
                                a.unshift(n);
                            for (n = t; n = n.parentNode;)
                                s.unshift(n);
                            for (; a[o] === s[o];)
                                o++;
                            return o ? ae(a[o], s[o]) : a[o] === T ? -1 : s[o] === T ? 1 : 0
                        }
                    ,
                    l) : k
            }
            ,
            te.matches = function (e, t) {
                return te(e, null, null, t)
            }
            ,
            te.matchesSelector = function (e, t) {
                if ((e.ownerDocument || e) !== k && m(e),
                    t = t.replace(R, "='$1']"),
                    !(!f.matchesSelector || !y || i && i.test(t) || g && g.test(t)))
                    try {
                        var n = a.call(e, t);
                        if (n || f.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                            return n
                    } catch (e) { }
                return 0 < te(t, k, null, [e]).length
            }
            ,
            te.contains = function (e, t) {
                return (e.ownerDocument || e) !== k && m(e),
                    v(e, t)
            }
            ,
            te.attr = function (e, t) {
                (e.ownerDocument || e) !== k && m(e);
                var n = x.attrHandle[t.toLowerCase()]
                    , n = n && N.call(x.attrHandle, t.toLowerCase()) ? n(e, t, !y) : void 0;
                return void 0 !== n ? n : f.attributes || !y ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
            }
            ,
            te.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e)
            }
            ,
            te.uniqueSort = function (e) {
                var t, n = [], o = 0, i = 0;
                if (u = !f.detectDuplicates,
                    c = !f.sortStable && e.slice(0),
                    e.sort(_),
                    u) {
                    for (; t = e[i++];)
                        t === e[i] && (o = n.push(i));
                    for (; o--;)
                        e.splice(n[o], 1)
                }
                return c = null,
                    e
            }
            ,
            r = te.getText = function (e) {
                var t, n = "", o = 0, i = e.nodeType;
                if (i) {
                    if (1 === i || 9 === i || 11 === i) {
                        if ("string" == typeof e.textContent)
                            return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling)
                            n += r(e)
                    } else if (3 === i || 4 === i)
                        return e.nodeValue
                } else
                    for (; t = e[o++];)
                        n += r(t);
                return n
            }
            ,
            (x = te.selectors = {
                cacheLength: 50,
                createPseudo: oe,
                match: X,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function (e) {
                        return e[1] = e[1].replace(K, ee),
                            e[3] = (e[4] || e[5] || "").replace(K, ee),
                            "~=" === e[2] && (e[3] = " " + e[3] + " "),
                            e.slice(0, 4)
                    },
                    CHILD: function (e) {
                        return e[1] = e[1].toLowerCase(),
                            "nth" === e[1].slice(0, 3) ? (e[3] || te.error(e[0]),
                                e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                                e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && te.error(e[0]),
                            e
                    },
                    PSEUDO: function (e) {
                        var t, n = !e[5] && e[2];
                        return X.CHILD.test(e[0]) ? null : (e[3] && void 0 !== e[4] ? e[2] = e[4] : n && $.test(n) && (t = ue(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t),
                            e[2] = n.slice(0, t)),
                            e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function (e) {
                        var t = e.replace(K, ee).toLowerCase();
                        return "*" === e ? function () {
                            return !0
                        }
                            : function (e) {
                                return e.nodeName && e.nodeName.toLowerCase() === t
                            }
                    },
                    CLASS: function (e) {
                        var t = s[e + " "];
                        return t || (t = new RegExp("(^|" + q + ")" + e + "(" + q + "|$)")) && s(e, function (e) {
                            return t.test("string" == typeof e.className && e.className || typeof e.getAttribute !== j && e.getAttribute("class") || "")
                        })
                    },
                    ATTR: function (t, n, o) {
                        return function (e) {
                            e = te.attr(e, t);
                            return null == e ? "!=" === n : !n || (e += "",
                                "=" === n ? e === o : "!=" === n ? e !== o : "^=" === n ? o && 0 === e.indexOf(o) : "*=" === n ? o && -1 < e.indexOf(o) : "$=" === n ? o && e.slice(-o.length) === o : "~=" === n ? -1 < (" " + e + " ").indexOf(o) : "|=" === n && (e === o || e.slice(0, o.length + 1) === o + "-"))
                        }
                    },
                    CHILD: function (f, e, t, h, m) {
                        var y = "nth" !== f.slice(0, 3)
                            , g = "last" !== f.slice(-4)
                            , v = "of-type" === e;
                        return 1 === h && 0 === m ? function (e) {
                            return !!e.parentNode
                        }
                            : function (e, t, n) {
                                var o, i, r, a, s, l, c = y != g ? "nextSibling" : "previousSibling", u = e.parentNode, d = v && e.nodeName.toLowerCase(), p = !n && !v;
                                if (u) {
                                    if (y) {
                                        for (; c;) {
                                            for (r = e; r = r[c];)
                                                if (v ? r.nodeName.toLowerCase() === d : 1 === r.nodeType)
                                                    return !1;
                                            l = c = "only" === f && !l && "nextSibling"
                                        }
                                        return !0
                                    }
                                    if (l = [g ? u.firstChild : u.lastChild],
                                        g && p) {
                                        for (s = (o = (i = u[b] || (u[b] = {}))[f] || [])[0] === C && o[1],
                                            a = o[0] === C && o[2],
                                            r = s && u.childNodes[s]; r = ++s && r && r[c] || (a = s = 0) || l.pop();)
                                            if (1 === r.nodeType && ++a && r === e) {
                                                i[f] = [C, s, a];
                                                break
                                            }
                                    } else if (p && (o = (e[b] || (e[b] = {}))[f]) && o[0] === C)
                                        a = o[1];
                                    else
                                        for (; (r = ++s && r && r[c] || (a = s = 0) || l.pop()) && ((v ? r.nodeName.toLowerCase() !== d : 1 !== r.nodeType) || !++a || (p && ((r[b] || (r[b] = {}))[f] = [C, a]),
                                            r !== e));)
                                            ;
                                    return (a -= m) === h || a % h == 0 && 0 <= a / h
                                }
                            }
                    },
                    PSEUDO: function (e, r) {
                        var t, a = x.pseudos[e] || x.setFilters[e.toLowerCase()] || te.error("unsupported pseudo: " + e);
                        return a[b] ? a(r) : 1 < a.length ? (t = [e, e, "", r],
                            x.setFilters.hasOwnProperty(e.toLowerCase()) ? oe(function (e, t) {
                                for (var n, o = a(e, r), i = o.length; i--;)
                                    e[n = L.call(e, o[i])] = !(t[n] = o[i])
                            }) : function (e) {
                                return a(e, 0, t)
                            }
                        ) : a
                    }
                },
                pseudos: {
                    not: oe(function (e) {
                        var o = []
                            , i = []
                            , s = h(e.replace(Q, "$1"));
                        return s[b] ? oe(function (e, t, n, o) {
                            for (var i, r = s(e, null, o, []), a = e.length; a--;)
                                (i = r[a]) && (e[a] = !(t[a] = i))
                        }) : function (e, t, n) {
                            return o[0] = e,
                                s(o, null, n, i),
                                !i.pop()
                        }
                    }),
                    has: oe(function (t) {
                        return function (e) {
                            return 0 < te(t, e).length
                        }
                    }),
                    contains: oe(function (t) {
                        return function (e) {
                            return -1 < (e.textContent || e.innerText || r(e)).indexOf(t)
                        }
                    }),
                    lang: oe(function (n) {
                        return I.test(n || "") || te.error("unsupported lang: " + n),
                            n = n.replace(K, ee).toLowerCase(),
                            function (e) {
                                var t;
                                do {
                                    if (t = y ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                        return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-")
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1
                            }
                    }),
                    target: function (e) {
                        var t = n.location && n.location.hash;
                        return t && t.slice(1) === e.id
                    },
                    root: function (e) {
                        return e === o
                    },
                    focus: function (e) {
                        return e === k.activeElement && (!k.hasFocus || k.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: function (e) {
                        return !1 === e.disabled
                    },
                    disabled: function (e) {
                        return !0 === e.disabled
                    },
                    checked: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                    },
                    selected: function (e) {
                        return e.parentNode && e.parentNode.selectedIndex,
                            !0 === e.selected
                    },
                    empty: function (e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6)
                                return !1;
                        return !0
                    },
                    parent: function (e) {
                        return !x.pseudos.empty(e)
                    },
                    header: function (e) {
                        return U.test(e.nodeName)
                    },
                    input: function (e) {
                        return V.test(e.nodeName)
                    },
                    button: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && "button" === e.type || "button" === t
                    },
                    text: function (e) {
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (e = e.getAttribute("type")) || "text" === e.toLowerCase())
                    },
                    first: se(function () {
                        return [0]
                    }),
                    last: se(function (e, t) {
                        return [t - 1]
                    }),
                    eq: se(function (e, t, n) {
                        return [n < 0 ? n + t : n]
                    }),
                    even: se(function (e, t) {
                        for (var n = 0; n < t; n += 2)
                            e.push(n);
                        return e
                    }),
                    odd: se(function (e, t) {
                        for (var n = 1; n < t; n += 2)
                            e.push(n);
                        return e
                    }),
                    lt: se(function (e, t, n) {
                        for (var o = n < 0 ? n + t : n; 0 <= --o;)
                            e.push(o);
                        return e
                    }),
                    gt: se(function (e, t, n) {
                        for (var o = n < 0 ? n + t : n; ++o < t;)
                            e.push(o);
                        return e
                    })
                }
            }).pseudos.nth = x.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            x.pseudos[e] = function (t) {
                return function (e) {
                    return "input" === e.nodeName.toLowerCase() && e.type === t
                }
            }(e);
        for (e in {
            submit: !0,
            reset: !0
        })
            x.pseudos[e] = function (n) {
                return function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t || "button" === t) && e.type === n
                }
            }(e);
        function ce() { }
        function ue(e, t) {
            var n, o, i, r, a, s, l, c = p[e + " "];
            if (c)
                return t ? 0 : c.slice(0);
            for (a = e,
                s = [],
                l = x.preFilter; a;) {
                for (r in n && !(o = P.exec(a)) || (o && (a = a.slice(o[0].length) || a),
                    s.push(i = [])),
                    n = !1,
                    (o = W.exec(a)) && (n = o.shift(),
                        i.push({
                            value: n,
                            type: o[0].replace(Q, " ")
                        }),
                        a = a.slice(n.length)),
                    x.filter)
                    !(o = X[r].exec(a)) || l[r] && !(o = l[r](o)) || (n = o.shift(),
                        i.push({
                            value: n,
                            type: r,
                            matches: o
                        }),
                        a = a.slice(n.length));
                if (!n)
                    break
            }
            return t ? a.length : a ? te.error(e) : p(e, s).slice(0)
        }
        function de(e) {
            for (var t = 0, n = e.length, o = ""; t < n; t++)
                o += e[t].value;
            return o
        }
        function pe(a, e, t) {
            var s = e.dir
                , l = t && "parentNode" === s
                , c = d++;
            return e.first ? function (e, t, n) {
                for (; e = e[s];)
                    if (1 === e.nodeType || l)
                        return a(e, t, n)
            }
                : function (e, t, n) {
                    var o, i, r = [C, c];
                    if (n) {
                        for (; e = e[s];)
                            if ((1 === e.nodeType || l) && a(e, t, n))
                                return !0
                    } else
                        for (; e = e[s];)
                            if (1 === e.nodeType || l) {
                                if ((o = (i = e[b] || (e[b] = {}))[s]) && o[0] === C && o[1] === c)
                                    return r[2] = o[2];
                                if ((i[s] = r)[2] = a(e, t, n))
                                    return !0
                            }
                }
        }
        function fe(i) {
            return 1 < i.length ? function (e, t, n) {
                for (var o = i.length; o--;)
                    if (!i[o](e, t, n))
                        return !1;
                return !0
            }
                : i[0]
        }
        function he(e, t, n, o, i) {
            for (var r, a = [], s = 0, l = e.length, c = null != t; s < l; s++)
                !(r = e[s]) || n && !n(r, o, i) || (a.push(r),
                    c && t.push(s));
            return a
        }
        function me(f, h, m, y, g, e) {
            return y && !y[b] && (y = me(y)),
                g && !g[b] && (g = me(g, e)),
                oe(function (e, t, n, o) {
                    var i, r, a, s = [], l = [], c = t.length, u = e || function (e, t, n) {
                        for (var o = 0, i = t.length; o < i; o++)
                            te(e, t[o], n);
                        return n
                    }(h || "*", n.nodeType ? [n] : n, []), d = !f || !e && h ? u : he(u, s, f, n, o), p = m ? g || (e ? f : c || y) ? [] : t : d;
                    if (m && m(d, p, n, o),
                        y)
                        for (i = he(p, l),
                            y(i, [], n, o),
                            r = i.length; r--;)
                            (a = i[r]) && (p[l[r]] = !(d[l[r]] = a));
                    if (e) {
                        if (g || f) {
                            if (g) {
                                for (i = [],
                                    r = p.length; r--;)
                                    (a = p[r]) && i.push(d[r] = a);
                                g(null, p = [], i, o)
                            }
                            for (r = p.length; r--;)
                                (a = p[r]) && -1 < (i = g ? L.call(e, a) : s[r]) && (e[i] = !(t[i] = a))
                        }
                    } else
                        p = he(p === t ? p.splice(c, p.length) : p),
                            g ? g(null, t, p, o) : z.apply(t, p)
                })
        }
        function ye(y, g) {
            function e(e, t, n, o, i) {
                var r, a, s, l = 0, c = "0", u = e && [], d = [], p = w, f = e || b && x.find.TAG("*", i), h = C += null == p ? 1 : Math.random() || .1, m = f.length;
                for (i && (w = t !== k && t); c !== m && null != (r = f[c]); c++) {
                    if (b && r) {
                        for (a = 0; s = y[a++];)
                            if (s(r, t, n)) {
                                o.push(r);
                                break
                            }
                        i && (C = h)
                    }
                    v && ((r = !s && r) && l--,
                        e && u.push(r))
                }
                if (l += c,
                    v && c !== l) {
                    for (a = 0; s = g[a++];)
                        s(u, d, t, n);
                    if (e) {
                        if (0 < l)
                            for (; c--;)
                                u[c] || d[c] || (d[c] = S.call(o));
                        d = he(d)
                    }
                    z.apply(o, d),
                        i && !e && 0 < d.length && 1 < l + g.length && te.uniqueSort(o)
                }
                return i && (C = h,
                    w = p),
                    u
            }
            var v = 0 < g.length
                , b = 0 < y.length;
            return v ? oe(e) : e
        }
        return ce.prototype = x.filters = x.pseudos,
            x.setFilters = new ce,
            h = te.compile = function (e, t) {
                var n, o = [], i = [], r = l[e + " "];
                if (!r) {
                    for (n = (t = t || ue(e)).length; n--;)
                        ((r = function e(t) {
                            for (var o, n, i, r = t.length, a = x.relative[t[0].type], s = a || x.relative[" "], l = a ? 1 : 0, c = pe(function (e) {
                                return e === o
                            }, s, !0), u = pe(function (e) {
                                return -1 < L.call(o, e)
                            }, s, !0), d = [function (e, t, n) {
                                return !a && (n || t !== w) || ((o = t).nodeType ? c : u)(e, t, n)
                            }
                            ]; l < r; l++)
                                if (n = x.relative[t[l].type])
                                    d = [pe(fe(d), n)];
                                else {
                                    if ((n = x.filter[t[l].type].apply(null, t[l].matches))[b]) {
                                        for (i = ++l; i < r && !x.relative[t[i].type]; i++)
                                            ;
                                        return me(1 < l && fe(d), 1 < l && de(t.slice(0, l - 1).concat({
                                            value: " " === t[l - 2].type ? "*" : ""
                                        })).replace(Q, "$1"), n, l < i && e(t.slice(l, i)), i < r && e(t = t.slice(i)), i < r && de(t))
                                    }
                                    d.push(n)
                                }
                            return fe(d)
                        }(t[n]))[b] ? o : i).push(r);
                    r = l(e, ye(i, o))
                }
                return r
            }
            ,
            f.sortStable = b.split("").sort(_).join("") === b,
            f.detectDuplicates = !!u,
            m(),
            f.sortDetached = ie(function (e) {
                return 1 & e.compareDocumentPosition(k.createElement("div"))
            }),
            ie(function (e) {
                return e.innerHTML = "<a href='#'></a>",
                    "#" === e.firstChild.getAttribute("href")
            }) || re("type|href|height|width", function (e, t, n) {
                return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
            }),
            f.attributes && ie(function (e) {
                return e.innerHTML = "<input/>",
                    e.firstChild.setAttribute("value", ""),
                    "" === e.firstChild.getAttribute("value")
            }) || re("value", function (e, t, n) {
                return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
            }),
            ie(function (e) {
                return null == e.getAttribute("disabled")
            }) || re(H, function (e, t, n) {
                return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (t = e.getAttributeNode(t)) && t.specified ? t.value : null
            }),
            te
    }(h);
    w.find = v,
        w.expr = v.selectors,
        w.expr[":"] = w.expr.pseudos,
        w.unique = v.uniqueSort,
        w.text = v.getText,
        w.isXMLDoc = v.isXML,
        w.contains = v.contains;
    var b = w.expr.match.needsContext
        , x = /^<(\w+)\s*\/?>(?:<\/\1>|)$/
        , k = /^.[^:#\[\.,]*$/;
    function T(e, n, o) {
        if (w.isFunction(n))
            return w.grep(e, function (e, t) {
                return !!n.call(e, t, e) !== o
            });
        if (n.nodeType)
            return w.grep(e, function (e) {
                return e === n !== o
            });
        if ("string" == typeof n) {
            if (k.test(n))
                return w.filter(n, e, o);
            n = w.filter(n, e)
        }
        return w.grep(e, function (e) {
            return 0 <= w.inArray(e, n) !== o
        })
    }
    w.filter = function (e, t, n) {
        var o = t[0];
        return n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === o.nodeType ? w.find.matchesSelector(o, e) ? [o] : [] : w.find.matches(e, w.grep(t, function (e) {
                return 1 === e.nodeType
            }))
    }
        ,
        w.fn.extend({
            find: function (e) {
                var t, n = [], o = this, i = o.length;
                if ("string" != typeof e)
                    return this.pushStack(w(e).filter(function () {
                        for (t = 0; t < i; t++)
                            if (w.contains(o[t], this))
                                return !0
                    }));
                for (t = 0; t < i; t++)
                    w.find(e, o[t], n);
                return (n = this.pushStack(1 < i ? w.unique(n) : n)).selector = this.selector ? this.selector + " " + e : e,
                    n
            },
            filter: function (e) {
                return this.pushStack(T(this, e || [], !1))
            },
            not: function (e) {
                return this.pushStack(T(this, e || [], !0))
            },
            is: function (e) {
                return !!T(this, "string" == typeof e && b.test(e) ? w(e) : e || [], !1).length
            }
        });
    var C, _ = h.document, j = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (w.fn.init = function (e, t) {
        var n, o;
        if (!e)
            return this;
        if ("string" != typeof e)
            return e.nodeType ? (this.context = this[0] = e,
                this.length = 1,
                this) : w.isFunction(e) ? void 0 !== C.ready ? C.ready(e) : e(w) : (void 0 !== e.selector && (this.selector = e.selector,
                    this.context = e.context),
                    w.makeArray(e, this));
        if (!(n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && 3 <= e.length ? [null, e, null] : j.exec(e)) || !n[1] && t)
            return (!t || t.jquery ? t || C : this.constructor(t)).find(e);
        if (n[1]) {
            if (t = t instanceof w ? t[0] : t,
                w.merge(this, w.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : _, !0)),
                x.test(n[1]) && w.isPlainObject(t))
                for (n in t)
                    w.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
            return this
        }
        if ((o = _.getElementById(n[2])) && o.parentNode) {
            if (o.id !== n[2])
                return C.find(e);
            this.length = 1,
                this[0] = o
        }
        return this.context = _,
            this.selector = e,
            this
    }
    ).prototype = w.fn,
        C = w(_);
    var N = /^(?:parents|prev(?:Until|All))/
        , E = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
    function S(e, t) {
        for (; e = e[t],
            e && 1 !== e.nodeType;)
            ;
        return e
    }
    w.extend({
        dir: function (e, t, n) {
            for (var o = [], i = e[t]; i && 9 !== i.nodeType && (void 0 === n || 1 !== i.nodeType || !w(i).is(n));)
                1 === i.nodeType && o.push(i),
                    i = i[t];
            return o
        },
        sibling: function (e, t) {
            for (var n = []; e; e = e.nextSibling)
                1 === e.nodeType && e !== t && n.push(e);
            return n
        }
    }),
        w.fn.extend({
            has: function (e) {
                var t, n = w(e, this), o = n.length;
                return this.filter(function () {
                    for (t = 0; t < o; t++)
                        if (w.contains(this, n[t]))
                            return !0
                })
            },
            closest: function (e, t) {
                for (var n, o = 0, i = this.length, r = [], a = b.test(e) || "string" != typeof e ? w(e, t || this.context) : 0; o < i; o++)
                    for (n = this[o]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
                            r.push(n);
                            break
                        }
                return this.pushStack(1 < r.length ? w.unique(r) : r)
            },
            index: function (e) {
                return e ? "string" == typeof e ? w.inArray(this[0], w(e)) : w.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
            },
            add: function (e, t) {
                return this.pushStack(w.unique(w.merge(this.get(), w(e, t))))
            },
            addBack: function (e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
            }
        }),
        w.each({
            parent: function (e) {
                e = e.parentNode;
                return e && 11 !== e.nodeType ? e : null
            },
            parents: function (e) {
                return w.dir(e, "parentNode")
            },
            parentsUntil: function (e, t, n) {
                return w.dir(e, "parentNode", n)
            },
            next: function (e) {
                return S(e, "nextSibling")
            },
            prev: function (e) {
                return S(e, "previousSibling")
            },
            nextAll: function (e) {
                return w.dir(e, "nextSibling")
            },
            prevAll: function (e) {
                return w.dir(e, "previousSibling")
            },
            nextUntil: function (e, t, n) {
                return w.dir(e, "nextSibling", n)
            },
            prevUntil: function (e, t, n) {
                return w.dir(e, "previousSibling", n)
            },
            siblings: function (e) {
                return w.sibling((e.parentNode || {}).firstChild, e)
            },
            children: function (e) {
                return w.sibling(e.firstChild)
            },
            contents: function (e) {
                return w.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : w.merge([], e.childNodes)
            }
        }, function (o, i) {
            w.fn[o] = function (e, t) {
                var n = w.map(this, i, e);
                return "Until" !== o.slice(-5) && (t = e),
                    t && "string" == typeof t && (n = w.filter(t, n)),
                    1 < this.length && (E[o] || (n = w.unique(n)),
                        N.test(o) && (n = n.reverse())),
                    this.pushStack(n)
            }
        });
    var A, z = /\S+/g, D = {};
    function L() {
        _.addEventListener ? (_.removeEventListener("DOMContentLoaded", H, !1),
            h.removeEventListener("load", H, !1)) : (_.detachEvent("onreadystatechange", H),
                h.detachEvent("onload", H))
    }
    function H() {
        !_.addEventListener && "load" !== event.type && "complete" !== _.readyState || (L(),
            w.ready())
    }
    w.Callbacks = function (i) {
        var e, n;
        i = "string" == typeof i ? D[i] || (n = D[e = i] = {},
            w.each(e.match(z) || [], function (e, t) {
                n[t] = !0
            }),
            n) : w.extend({}, i);
        var o, t, r, a, s, l, c = [], u = !i.once && [], d = function (e) {
            for (t = i.memory && e,
                r = !0,
                s = l || 0,
                l = 0,
                a = c.length,
                o = !0; c && s < a; s++)
                if (!1 === c[s].apply(e[0], e[1]) && i.stopOnFalse) {
                    t = !1;
                    break
                }
            o = !1,
                c && (u ? u.length && d(u.shift()) : t ? c = [] : p.disable())
        }, p = {
            add: function () {
                var e;
                return c && (e = c.length,
                    function o(e) {
                        w.each(e, function (e, t) {
                            var n = w.type(t);
                            "function" === n ? i.unique && p.has(t) || c.push(t) : t && t.length && "string" !== n && o(t)
                        })
                    }(arguments),
                    o ? a = c.length : t && (l = e,
                        d(t))),
                    this
            },
            remove: function () {
                return c && w.each(arguments, function (e, t) {
                    for (var n; -1 < (n = w.inArray(t, c, n));)
                        c.splice(n, 1),
                            o && (n <= a && a--,
                                n <= s && s--)
                }),
                    this
            },
            has: function (e) {
                return e ? -1 < w.inArray(e, c) : !(!c || !c.length)
            },
            empty: function () {
                return c = [],
                    a = 0,
                    this
            },
            disable: function () {
                return c = u = t = void 0,
                    this
            },
            disabled: function () {
                return !c
            },
            lock: function () {
                return u = void 0,
                    t || p.disable(),
                    this
            },
            locked: function () {
                return !u
            },
            fireWith: function (e, t) {
                return !c || r && !u || (t = [e, (t = t || []).slice ? t.slice() : t],
                    o ? u.push(t) : d(t)),
                    this
            },
            fire: function () {
                return p.fireWith(this, arguments),
                    this
            },
            fired: function () {
                return !!r
            }
        };
        return p
    }
        ,
        w.extend({
            Deferred: function (e) {
                var r = [["resolve", "done", w.Callbacks("once memory"), "resolved"], ["reject", "fail", w.Callbacks("once memory"), "rejected"], ["notify", "progress", w.Callbacks("memory")]]
                    , i = "pending"
                    , a = {
                        state: function () {
                            return i
                        },
                        always: function () {
                            return s.done(arguments).fail(arguments),
                                this
                        },
                        then: function () {
                            var i = arguments;
                            return w.Deferred(function (o) {
                                w.each(r, function (e, t) {
                                    var n = w.isFunction(i[e]) && i[e];
                                    s[t[1]](function () {
                                        var e = n && n.apply(this, arguments);
                                        e && w.isFunction(e.promise) ? e.promise().done(o.resolve).fail(o.reject).progress(o.notify) : o[t[0] + "With"](this === a ? o.promise() : this, n ? [e] : arguments)
                                    })
                                }),
                                    i = null
                            }).promise()
                        },
                        promise: function (e) {
                            return null != e ? w.extend(e, a) : a
                        }
                    }
                    , s = {};
                return a.pipe = a.then,
                    w.each(r, function (e, t) {
                        var n = t[2]
                            , o = t[3];
                        a[t[1]] = n.add,
                            o && n.add(function () {
                                i = o
                            }, r[1 ^ e][2].disable, r[2][2].lock),
                            s[t[0]] = function () {
                                return s[t[0] + "With"](this === s ? a : this, arguments),
                                    this
                            }
                            ,
                            s[t[0] + "With"] = n.fireWith
                    }),
                    a.promise(s),
                    e && e.call(s, s),
                    s
            },
            when: function (e) {
                function t(t, n, o) {
                    return function (e) {
                        n[t] = this,
                            o[t] = 1 < arguments.length ? u.call(arguments) : e,
                            o === i ? c.notifyWith(n, o) : --l || c.resolveWith(n, o)
                    }
                }
                var i, n, o, r = 0, a = u.call(arguments), s = a.length, l = 1 !== s || e && w.isFunction(e.promise) ? s : 0, c = 1 === l ? e : w.Deferred();
                if (1 < s)
                    for (i = new Array(s),
                        n = new Array(s),
                        o = new Array(s); r < s; r++)
                        a[r] && w.isFunction(a[r].promise) ? a[r].promise().done(t(r, o, a)).fail(c.reject).progress(t(r, n, i)) : --l;
                return l || c.resolveWith(o, a),
                    c.promise()
            }
        }),
        w.fn.ready = function (e) {
            return w.ready.promise().done(e),
                this
        }
        ,
        w.extend({
            isReady: !1,
            readyWait: 1,
            holdReady: function (e) {
                e ? w.readyWait++ : w.ready(!0)
            },
            ready: function (e) {
                if (!0 === e ? !--w.readyWait : !w.isReady) {
                    if (!_.body)
                        return setTimeout(w.ready);
                    (w.isReady = !0) !== e && 0 < --w.readyWait || (A.resolveWith(_, [w]),
                        w.fn.trigger && w(_).trigger("ready").off("ready"))
                }
            }
        }),
        w.ready.promise = function (e) {
            if (!A)
                if (A = w.Deferred(),
                    "complete" === _.readyState)
                    setTimeout(w.ready);
                else if (_.addEventListener)
                    _.addEventListener("DOMContentLoaded", H, !1),
                        h.addEventListener("load", H, !1);
                else {
                    _.attachEvent("onreadystatechange", H),
                        h.attachEvent("onload", H);
                    var n = !1;
                    try {
                        n = null == h.frameElement && _.documentElement
                    } catch (e) { }
                    n && n.doScroll && !function t() {
                        if (!w.isReady) {
                            try {
                                n.doScroll("left")
                            } catch (e) {
                                return setTimeout(t, 50)
                            }
                            L(),
                                w.ready()
                        }
                    }()
                }
            return A.promise(e)
        }
        ;
    var q, F = "undefined";
    for (q in w(g))
        break;
    g.ownLast = "0" !== q,
        g.inlineBlockNeedsLayout = !1,
        w(function () {
            var e, t, n = _.getElementsByTagName("body")[0];
            n && ((e = _.createElement("div")).style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px",
                t = _.createElement("div"),
                n.appendChild(e).appendChild(t),
                typeof t.style.zoom !== F && (t.style.cssText = "border:0;margin:0;width:1px;padding:1px;display:inline;zoom:1",
                    (g.inlineBlockNeedsLayout = 3 === t.offsetWidth) && (n.style.zoom = 1)),
                n.removeChild(e),
                e = t = null)
        }),
        function () {
            var e = _.createElement("div");
            if (null == g.deleteExpando) {
                g.deleteExpando = !0;
                try {
                    delete e.test
                } catch (e) {
                    g.deleteExpando = !1
                }
            }
            e = null
        }(),
        w.acceptData = function (e) {
            var t = w.noData[(e.nodeName + " ").toLowerCase()]
                , n = +e.nodeType || 1;
            return (1 === n || 9 === n) && (!t || !0 !== t && e.getAttribute("classid") === t)
        }
        ;
    var M = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
        , O = /([A-Z])/g;
    function B(e, t, n) {
        if (void 0 === n && 1 === e.nodeType) {
            var o = "data-" + t.replace(O, "-$1").toLowerCase();
            if ("string" == typeof (n = e.getAttribute(o))) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : M.test(n) ? w.parseJSON(n) : n)
                } catch (e) { }
                w.data(e, t, n)
            } else
                n = void 0
        }
        return n
    }
    function Q(e) {
        for (var t in e)
            if (("data" !== t || !w.isEmptyObject(e[t])) && "toJSON" !== t)
                return;
        return 1
    }
    function P(e, t, n, o) {
        if (w.acceptData(e)) {
            var i, r = w.expando, a = e.nodeType, s = a ? w.cache : e, l = a ? e[r] : e[r] && r;
            if (l && s[l] && (o || s[l].data) || void 0 !== n || "string" != typeof t)
                return s[l = l || (a ? e[r] = d.pop() || w.guid++ : r)] || (s[l] = a ? {} : {
                    toJSON: w.noop
                }),
                    "object" != typeof t && "function" != typeof t || (o ? s[l] = w.extend(s[l], t) : s[l].data = w.extend(s[l].data, t)),
                    l = s[l],
                    o || (l.data || (l.data = {}),
                        l = l.data),
                    void 0 !== n && (l[w.camelCase(t)] = n),
                    "string" == typeof t ? null == (i = l[t]) && (i = l[w.camelCase(t)]) : i = l,
                    i
        }
    }
    function W(e, t, n) {
        if (w.acceptData(e)) {
            var o, i, r = e.nodeType, a = r ? w.cache : e, s = r ? e[w.expando] : w.expando;
            if (a[s]) {
                if (t && (o = n ? a[s] : a[s].data)) {
                    i = (t = w.isArray(t) ? t.concat(w.map(t, w.camelCase)) : t in o ? [t] : (t = w.camelCase(t)) in o ? [t] : t.split(" ")).length;
                    for (; i--;)
                        delete o[t[i]];
                    if (n ? !Q(o) : !w.isEmptyObject(o))
                        return
                }
                (n || (delete a[s].data,
                    Q(a[s]))) && (r ? w.cleanData([e], !0) : g.deleteExpando || a != a.window ? delete a[s] : a[s] = null)
            }
        }
    }
    w.extend({
        cache: {},
        noData: {
            "applet ": !0,
            "embed ": !0,
            "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
        },
        hasData: function (e) {
            return !!(e = e.nodeType ? w.cache[e[w.expando]] : e[w.expando]) && !Q(e)
        },
        data: function (e, t, n) {
            return P(e, t, n)
        },
        removeData: function (e, t) {
            return W(e, t)
        },
        _data: function (e, t, n) {
            return P(e, t, n, !0)
        },
        _removeData: function (e, t) {
            return W(e, t, !0)
        }
    }),
        w.fn.extend({
            data: function (e, t) {
                var n, o, i, r = this[0], a = r && r.attributes;
                if (void 0 !== e)
                    return "object" == typeof e ? this.each(function () {
                        w.data(this, e)
                    }) : 1 < arguments.length ? this.each(function () {
                        w.data(this, e, t)
                    }) : r ? B(r, e, w.data(r, e)) : void 0;
                if (this.length && (i = w.data(r),
                    1 === r.nodeType && !w._data(r, "parsedAttrs"))) {
                    for (n = a.length; n--;)
                        0 === (o = a[n].name).indexOf("data-") && B(r, o = w.camelCase(o.slice(5)), i[o]);
                    w._data(r, "parsedAttrs", !0)
                }
                return i
            },
            removeData: function (e) {
                return this.each(function () {
                    w.removeData(this, e)
                })
            }
        }),
        w.extend({
            queue: function (e, t, n) {
                var o;
                return e ? (t = (t || "fx") + "queue",
                    o = w._data(e, t),
                    n && (!o || w.isArray(n) ? o = w._data(e, t, w.makeArray(n)) : o.push(n)),
                    o || []) : void 0
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = w.queue(e, t)
                    , o = n.length
                    , i = n.shift()
                    , r = w._queueHooks(e, t);
                "inprogress" === i && (i = n.shift(),
                    o--),
                    i && ("fx" === t && n.unshift("inprogress"),
                        delete r.stop,
                        i.call(e, function () {
                            w.dequeue(e, t)
                        }, r)),
                    !o && r && r.empty.fire()
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return w._data(e, n) || w._data(e, n, {
                    empty: w.Callbacks("once memory").add(function () {
                        w._removeData(e, t + "queue"),
                            w._removeData(e, n)
                    })
                })
            }
        }),
        w.fn.extend({
            queue: function (t, n) {
                var e = 2;
                return "string" != typeof t && (n = t,
                    t = "fx",
                    e--),
                    arguments.length < e ? w.queue(this[0], t) : void 0 === n ? this : this.each(function () {
                        var e = w.queue(this, t, n);
                        w._queueHooks(this, t),
                            "fx" === t && "inprogress" !== e[0] && w.dequeue(this, t)
                    })
            },
            dequeue: function (e) {
                return this.each(function () {
                    w.dequeue(this, e)
                })
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", [])
            },
            promise: function (e, t) {
                function n() {
                    --i || r.resolveWith(a, [a])
                }
                var o, i = 1, r = w.Deferred(), a = this, s = this.length;
                for ("string" != typeof e && (t = e,
                    e = void 0),
                    e = e || "fx"; s--;)
                    (o = w._data(a[s], e + "queueHooks")) && o.empty && (i++,
                        o.empty.add(n));
                return n(),
                    r.promise(t)
            }
        });
    function R(e, t) {
        return e = t || e,
            "none" === w.css(e, "display") || !w.contains(e.ownerDocument, e)
    }
    var $ = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
        , I = ["Top", "Right", "Bottom", "Left"]
        , X = w.access = function (e, t, n, o, i, r, a) {
            var s = 0
                , l = e.length
                , c = null == n;
            if ("object" === w.type(n))
                for (s in i = !0,
                    n)
                    w.access(e, t, s, n[s], !0, r, a);
            else if (void 0 !== o && (i = !0,
                w.isFunction(o) || (a = !0),
                c && (t = a ? (t.call(e, o),
                    null) : (c = t,
                        function (e, t, n) {
                            return c.call(w(e), n)
                        }
                )),
                t))
                for (; s < l; s++)
                    t(e[s], n, a ? o : o.call(e[s], s, t(e[s], n)));
            return i ? e : c ? t.call(e) : l ? t(e[0], n) : r
        }
        , V = /^(?:checkbox|radio)$/i;
    !function () {
        var e = _.createDocumentFragment()
            , t = _.createElement("div")
            , n = _.createElement("input");
        if (t.setAttribute("className", "t"),
            t.innerHTML = "  <link/><table></table><a href='/a'>a</a>",
            g.leadingWhitespace = 3 === t.firstChild.nodeType,
            g.tbody = !t.getElementsByTagName("tbody").length,
            g.htmlSerialize = !!t.getElementsByTagName("link").length,
            g.html5Clone = "<:nav></:nav>" !== _.createElement("nav").cloneNode(!0).outerHTML,
            n.type = "checkbox",
            n.checked = !0,
            e.appendChild(n),
            g.appendChecked = n.checked,
            t.innerHTML = "<textarea>x</textarea>",
            g.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue,
            e.appendChild(t),
            t.innerHTML = "<input type='radio' checked='checked' name='t'/>",
            g.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked,
            g.noCloneEvent = !0,
            t.attachEvent && (t.attachEvent("onclick", function () {
                g.noCloneEvent = !1
            }),
                t.cloneNode(!0).click()),
            null == g.deleteExpando) {
            g.deleteExpando = !0;
            try {
                delete t.test
            } catch (e) {
                g.deleteExpando = !1
            }
        }
        e = t = n = null
    }(),
        function () {
            var e, t, n = _.createElement("div");
            for (e in {
                submit: !0,
                change: !0,
                focusin: !0
            })
                t = "on" + e,
                    (g[e + "Bubbles"] = t in h) || (n.setAttribute(t, "t"),
                        g[e + "Bubbles"] = !1 === n.attributes[t].expando);
            n = null
        }();
    var U = /^(?:input|select|textarea)$/i
        , Z = /^key/
        , J = /^(?:mouse|contextmenu)|click/
        , Y = /^(?:focusinfocus|focusoutblur)$/
        , G = /^([^.]*)(?:\.(.+)|)$/;
    function K() {
        return !0
    }
    function ee() {
        return !1
    }
    function te() {
        try {
            return _.activeElement
        } catch (e) { }
    }
    function ne(e) {
        var t = oe.split("|")
            , n = e.createDocumentFragment();
        if (n.createElement)
            for (; t.length;)
                n.createElement(t.pop());
        return n
    }
    w.event = {
        global: {},
        add: function (e, t, n, o, i) {
            var r, a, s, l, c, u, d, p, f, h = w._data(e);
            if (h) {
                for (n.handler && (n = (s = n).handler,
                    i = s.selector),
                    n.guid || (n.guid = w.guid++),
                    (r = h.events) || (r = h.events = {}),
                    (c = h.handle) || ((c = h.handle = function (e) {
                        return typeof w === F || e && w.event.triggered === e.type ? void 0 : w.event.dispatch.apply(c.elem, arguments)
                    }
                    ).elem = e),
                    a = (t = (t || "").match(z) || [""]).length; a--;)
                    d = f = (u = G.exec(t[a]) || [])[1],
                        p = (u[2] || "").split(".").sort(),
                        d && (l = w.event.special[d] || {},
                            d = (i ? l.delegateType : l.bindType) || d,
                            l = w.event.special[d] || {},
                            u = w.extend({
                                type: d,
                                origType: f,
                                data: o,
                                handler: n,
                                guid: n.guid,
                                selector: i,
                                needsContext: i && w.expr.match.needsContext.test(i),
                                namespace: p.join(".")
                            }, s),
                            (f = r[d]) || ((f = r[d] = []).delegateCount = 0,
                                l.setup && !1 !== l.setup.call(e, o, p, c) || (e.addEventListener ? e.addEventListener(d, c, !1) : e.attachEvent && e.attachEvent("on" + d, c))),
                            l.add && (l.add.call(e, u),
                                u.handler.guid || (u.handler.guid = n.guid)),
                            i ? f.splice(f.delegateCount++, 0, u) : f.push(u),
                            w.event.global[d] = !0);
                e = null
            }
        },
        remove: function (e, t, n, o, i) {
            var r, a, s, l, c, u, d, p, f, h, m, y = w.hasData(e) && w._data(e);
            if (y && (u = y.events)) {
                for (c = (t = (t || "").match(z) || [""]).length; c--;)
                    if (f = m = (s = G.exec(t[c]) || [])[1],
                        h = (s[2] || "").split(".").sort(),
                        f) {
                        for (d = w.event.special[f] || {},
                            p = u[f = (o ? d.delegateType : d.bindType) || f] || [],
                            s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                            l = r = p.length; r--;)
                            a = p[r],
                                !i && m !== a.origType || n && n.guid !== a.guid || s && !s.test(a.namespace) || o && o !== a.selector && ("**" !== o || !a.selector) || (p.splice(r, 1),
                                    a.selector && p.delegateCount--,
                                    d.remove && d.remove.call(e, a));
                        l && !p.length && (d.teardown && !1 !== d.teardown.call(e, h, y.handle) || w.removeEvent(e, f, y.handle),
                            delete u[f])
                    } else
                        for (f in u)
                            w.event.remove(e, f + t[c], n, o, !0);
                w.isEmptyObject(u) && (delete y.handle,
                    w._removeData(e, "events"))
            }
        },
        trigger: function (e, t, n, o) {
            var i, r, a, s, l, c, u = [n || _], d = y.call(e, "type") ? e.type : e, p = y.call(e, "namespace") ? e.namespace.split(".") : [], f = l = n = n || _;
            if (3 !== n.nodeType && 8 !== n.nodeType && !Y.test(d + w.event.triggered) && (0 <= d.indexOf(".") && (d = (p = d.split(".")).shift(),
                p.sort()),
                r = d.indexOf(":") < 0 && "on" + d,
                (e = e[w.expando] ? e : new w.Event(d, "object" == typeof e && e)).isTrigger = o ? 2 : 3,
                e.namespace = p.join("."),
                e.namespace_re = e.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
                e.result = void 0,
                e.target || (e.target = n),
                t = null == t ? [e] : w.makeArray(t, [e]),
                s = w.event.special[d] || {},
                o || !s.trigger || !1 !== s.trigger.apply(n, t))) {
                if (!o && !s.noBubble && !w.isWindow(n)) {
                    for (a = s.delegateType || d,
                        Y.test(a + d) || (f = f.parentNode); f; f = f.parentNode)
                        u.push(f),
                            l = f;
                    l === (n.ownerDocument || _) && u.push(l.defaultView || l.parentWindow || h)
                }
                for (c = 0; (f = u[c++]) && !e.isPropagationStopped();)
                    e.type = 1 < c ? a : s.bindType || d,
                        (i = (w._data(f, "events") || {})[e.type] && w._data(f, "handle")) && i.apply(f, t),
                        (i = r && f[r]) && i.apply && w.acceptData(f) && (e.result = i.apply(f, t),
                            !1 === e.result && e.preventDefault());
                if (e.type = d,
                    !o && !e.isDefaultPrevented() && (!s._default || !1 === s._default.apply(u.pop(), t)) && w.acceptData(n) && r && n[d] && !w.isWindow(n)) {
                    (l = n[r]) && (n[r] = null),
                        w.event.triggered = d;
                    try {
                        n[d]()
                    } catch (e) { }
                    w.event.triggered = void 0,
                        l && (n[r] = l)
                }
                return e.result
            }
        },
        dispatch: function (e) {
            e = w.event.fix(e);
            var t, n, o, i, r, a = u.call(arguments), s = (w._data(this, "events") || {})[e.type] || [], l = w.event.special[e.type] || {};
            if ((a[0] = e).delegateTarget = this,
                !l.preDispatch || !1 !== l.preDispatch.call(this, e)) {
                for (r = w.event.handlers.call(this, e, s),
                    t = 0; (o = r[t++]) && !e.isPropagationStopped();)
                    for (e.currentTarget = o.elem,
                        i = 0; (n = o.handlers[i++]) && !e.isImmediatePropagationStopped();)
                        e.namespace_re && !e.namespace_re.test(n.namespace) || (e.handleObj = n,
                            e.data = n.data,
                            void 0 !== (n = ((w.event.special[n.origType] || {}).handle || n.handler).apply(o.elem, a)) && !1 === (e.result = n) && (e.preventDefault(),
                                e.stopPropagation()));
                return l.postDispatch && l.postDispatch.call(this, e),
                    e.result
            }
        },
        handlers: function (e, t) {
            var n, o, i, r, a = [], s = t.delegateCount, l = e.target;
            if (s && l.nodeType && (!e.button || "click" !== e.type))
                for (; l != this; l = l.parentNode || this)
                    if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
                        for (i = [],
                            r = 0; r < s; r++)
                            void 0 === i[n = (o = t[r]).selector + " "] && (i[n] = o.needsContext ? 0 <= w(n, this).index(l) : w.find(n, this, null, [l]).length),
                                i[n] && i.push(o);
                        i.length && a.push({
                            elem: l,
                            handlers: i
                        })
                    }
            return s < t.length && a.push({
                elem: this,
                handlers: t.slice(s)
            }),
                a
        },
        fix: function (e) {
            if (e[w.expando])
                return e;
            var t, n, o, i = e.type, r = e, a = this.fixHooks[i];
            for (a || (this.fixHooks[i] = a = J.test(i) ? this.mouseHooks : Z.test(i) ? this.keyHooks : {}),
                o = a.props ? this.props.concat(a.props) : this.props,
                e = new w.Event(r),
                t = o.length; t--;)
                e[n = o[t]] = r[n];
            return e.target || (e.target = r.srcElement || _),
                3 === e.target.nodeType && (e.target = e.target.parentNode),
                e.metaKey = !!e.metaKey,
                a.filter ? a.filter(e, r) : e
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function (e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode),
                    e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function (e, t) {
                var n, o, i = t.button, r = t.fromElement;
                return null == e.pageX && null != t.clientX && (o = (n = e.target.ownerDocument || _).documentElement,
                    n = n.body,
                    e.pageX = t.clientX + (o && o.scrollLeft || n && n.scrollLeft || 0) - (o && o.clientLeft || n && n.clientLeft || 0),
                    e.pageY = t.clientY + (o && o.scrollTop || n && n.scrollTop || 0) - (o && o.clientTop || n && n.clientTop || 0)),
                    !e.relatedTarget && r && (e.relatedTarget = r === e.target ? t.toElement : r),
                    e.which || void 0 === i || (e.which = 1 & i ? 1 : 2 & i ? 3 : 4 & i ? 2 : 0),
                    e
            }
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function () {
                    if (this !== te() && this.focus)
                        try {
                            return this.focus(),
                                !1
                        } catch (e) { }
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function () {
                    return this === te() && this.blur ? (this.blur(),
                        !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function () {
                    return w.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(),
                        !1) : void 0
                },
                _default: function (e) {
                    return w.nodeName(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && (e.originalEvent.returnValue = e.result)
                }
            }
        },
        simulate: function (e, t, n, o) {
            e = w.extend(new w.Event, n, {
                type: e,
                isSimulated: !0,
                originalEvent: {}
            });
            o ? w.event.trigger(e, null, t) : w.event.dispatch.call(t, e),
                e.isDefaultPrevented() && n.preventDefault()
        }
    },
        w.removeEvent = _.removeEventListener ? function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n, !1)
        }
            : function (e, t, n) {
                t = "on" + t;
                e.detachEvent && (typeof e[t] === F && (e[t] = null),
                    e.detachEvent(t, n))
            }
        ,
        w.Event = function (e, t) {
            return this instanceof w.Event ? (e && e.type ? (this.originalEvent = e,
                this.type = e.type,
                this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && (!1 === e.returnValue || e.getPreventDefault && e.getPreventDefault()) ? K : ee) : this.type = e,
                t && w.extend(this, t),
                this.timeStamp = e && e.timeStamp || w.now(),
                void (this[w.expando] = !0)) : new w.Event(e, t)
        }
        ,
        w.Event.prototype = {
            isDefaultPrevented: ee,
            isPropagationStopped: ee,
            isImmediatePropagationStopped: ee,
            preventDefault: function () {
                var e = this.originalEvent;
                this.isDefaultPrevented = K,
                    e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1)
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                this.isPropagationStopped = K,
                    e && (e.stopPropagation && e.stopPropagation(),
                        e.cancelBubble = !0)
            },
            stopImmediatePropagation: function () {
                this.isImmediatePropagationStopped = K,
                    this.stopPropagation()
            }
        },
        w.each({
            mouseenter: "mouseover",
            mouseleave: "mouseout"
        }, function (e, i) {
            w.event.special[e] = {
                delegateType: i,
                bindType: i,
                handle: function (e) {
                    var t, n = e.relatedTarget, o = e.handleObj;
                    return n && (n === this || w.contains(this, n)) || (e.type = o.origType,
                        t = o.handler.apply(this, arguments),
                        e.type = i),
                        t
                }
            }
        }),
        g.submitBubbles || (w.event.special.submit = {
            setup: function () {
                return !w.nodeName(this, "form") && void w.event.add(this, "click._submit keypress._submit", function (e) {
                    e = e.target,
                        e = w.nodeName(e, "input") || w.nodeName(e, "button") ? e.form : void 0;
                    e && !w._data(e, "submitBubbles") && (w.event.add(e, "submit._submit", function (e) {
                        e._submit_bubble = !0
                    }),
                        w._data(e, "submitBubbles", !0))
                })
            },
            postDispatch: function (e) {
                e._submit_bubble && (delete e._submit_bubble,
                    this.parentNode && !e.isTrigger && w.event.simulate("submit", this.parentNode, e, !0))
            },
            teardown: function () {
                return !w.nodeName(this, "form") && void w.event.remove(this, "._submit")
            }
        }),
        g.changeBubbles || (w.event.special.change = {
            setup: function () {
                return U.test(this.nodeName) ? ("checkbox" !== this.type && "radio" !== this.type || (w.event.add(this, "propertychange._change", function (e) {
                    "checked" === e.originalEvent.propertyName && (this._just_changed = !0)
                }),
                    w.event.add(this, "click._change", function (e) {
                        this._just_changed && !e.isTrigger && (this._just_changed = !1),
                            w.event.simulate("change", this, e, !0)
                    })),
                    !1) : void w.event.add(this, "beforeactivate._change", function (e) {
                        e = e.target;
                        U.test(e.nodeName) && !w._data(e, "changeBubbles") && (w.event.add(e, "change._change", function (e) {
                            !this.parentNode || e.isSimulated || e.isTrigger || w.event.simulate("change", this.parentNode, e, !0)
                        }),
                            w._data(e, "changeBubbles", !0))
                    })
            },
            handle: function (e) {
                var t = e.target;
                return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0
            },
            teardown: function () {
                return w.event.remove(this, "._change"),
                    !U.test(this.nodeName)
            }
        }),
        g.focusinBubbles || w.each({
            focus: "focusin",
            blur: "focusout"
        }, function (n, o) {
            function i(e) {
                w.event.simulate(o, e.target, w.event.fix(e), !0)
            }
            w.event.special[o] = {
                setup: function () {
                    var e = this.ownerDocument || this
                        , t = w._data(e, o);
                    t || e.addEventListener(n, i, !0),
                        w._data(e, o, (t || 0) + 1)
                },
                teardown: function () {
                    var e = this.ownerDocument || this
                        , t = w._data(e, o) - 1;
                    t ? w._data(e, o, t) : (e.removeEventListener(n, i, !0),
                        w._removeData(e, o))
                }
            }
        }),
        w.fn.extend({
            on: function (e, t, n, o, i) {
                var r, a;
                if ("object" == typeof e) {
                    for (r in "string" != typeof t && (n = n || t,
                        t = void 0),
                        e)
                        this.on(r, t, n, e[r], i);
                    return this
                }
                if (null == n && null == o ? (o = t,
                    n = t = void 0) : null == o && ("string" == typeof t ? (o = n,
                        n = void 0) : (o = n,
                            n = t,
                            t = void 0)),
                    !1 === o)
                    o = ee;
                else if (!o)
                    return this;
                return 1 === i && (a = o,
                    (o = function (e) {
                        return w().off(e),
                            a.apply(this, arguments)
                    }
                    ).guid = a.guid || (a.guid = w.guid++)),
                    this.each(function () {
                        w.event.add(this, e, o, n, t)
                    })
            },
            one: function (e, t, n, o) {
                return this.on(e, t, n, o, 1)
            },
            off: function (e, t, n) {
                var o, i;
                if (e && e.preventDefault && e.handleObj)
                    return o = e.handleObj,
                        w(e.delegateTarget).off(o.namespace ? o.origType + "." + o.namespace : o.origType, o.selector, o.handler),
                        this;
                if ("object" != typeof e)
                    return !1 !== t && "function" != typeof t || (n = t,
                        t = void 0),
                        !1 === n && (n = ee),
                        this.each(function () {
                            w.event.remove(this, e, n, t)
                        });
                for (i in e)
                    this.off(i, t, e[i]);
                return this
            },
            trigger: function (e, t) {
                return this.each(function () {
                    w.event.trigger(e, t, this)
                })
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                return n ? w.event.trigger(e, t, n, !0) : void 0
            }
        });
    var oe = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video"
        , ie = / jQuery\d+="(?:null|\d+)"/g
        , re = new RegExp("<(?:" + oe + ")[\\s/>]", "i")
        , ae = /^\s+/
        , se = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi
        , le = /<([\w:]+)/
        , ce = /<tbody/i
        , ue = /<|&#?\w+;/
        , de = /<(?:script|style|link)/i
        , pe = /checked\s*(?:[^=]|=\s*.checked.)/i
        , fe = /^$|\/(?:java|ecma)script/i
        , he = /^true\/(.*)/
        , me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g
        , ye = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            legend: [1, "<fieldset>", "</fieldset>"],
            area: [1, "<map>", "</map>"],
            param: [1, "<object>", "</object>"],
            thead: [1, "<table>", "</table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: g.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
        }
        , ge = ne(_).appendChild(_.createElement("div"));
    function ve(e, t) {
        var n, o, i = 0, r = typeof e.getElementsByTagName !== F ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== F ? e.querySelectorAll(t || "*") : void 0;
        if (!r)
            for (r = [],
                n = e.childNodes || e; null != (o = n[i]); i++)
                !t || w.nodeName(o, t) ? r.push(o) : w.merge(r, ve(o, t));
        return void 0 === t || t && w.nodeName(e, t) ? w.merge([e], r) : r
    }
    function be(e) {
        V.test(e.type) && (e.defaultChecked = e.checked)
    }
    function xe(e, t) {
        return w.nodeName(e, "table") && w.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }
    function we(e) {
        return e.type = (null !== w.find.attr(e, "type")) + "/" + e.type,
            e
    }
    function ke(e) {
        var t = he.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"),
            e
    }
    function Te(e, t) {
        for (var n, o = 0; null != (n = e[o]); o++)
            w._data(n, "globalEval", !t || w._data(t[o], "globalEval"))
    }
    function Ce(e, t) {
        if (1 === t.nodeType && w.hasData(e)) {
            var n, o, i, r = w._data(e), e = w._data(t, r), a = r.events;
            if (a)
                for (n in delete e.handle,
                    e.events = {},
                    a)
                    for (o = 0,
                        i = a[n].length; o < i; o++)
                        w.event.add(t, n, a[n][o]);
            e.data && (e.data = w.extend({}, e.data))
        }
    }
    ye.optgroup = ye.option,
        ye.tbody = ye.tfoot = ye.colgroup = ye.caption = ye.thead,
        ye.th = ye.td,
        w.extend({
            clone: function (e, t, n) {
                var o, i, r, a, s, l = w.contains(e.ownerDocument, e);
                if (g.html5Clone || w.isXMLDoc(e) || !re.test("<" + e.nodeName + ">") ? r = e.cloneNode(!0) : (ge.innerHTML = e.outerHTML,
                    ge.removeChild(r = ge.firstChild)),
                    !(g.noCloneEvent && g.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e)))
                    for (o = ve(r),
                        s = ve(e),
                        a = 0; null != (i = s[a]); ++a)
                        o[a] && function (e, t) {
                            var n, o, i;
                            if (1 === t.nodeType) {
                                if (n = t.nodeName.toLowerCase(),
                                    !g.noCloneEvent && t[w.expando]) {
                                    for (o in (i = w._data(t)).events)
                                        w.removeEvent(t, o, i.handle);
                                    t.removeAttribute(w.expando)
                                }
                                "script" === n && t.text !== e.text ? (we(t).text = e.text,
                                    ke(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML),
                                        g.html5Clone && e.innerHTML && !w.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && V.test(e.type) ? (t.defaultChecked = t.checked = e.checked,
                                            t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
                            }
                        }(i, o[a]);
                if (t)
                    if (n)
                        for (s = s || ve(e),
                            o = o || ve(r),
                            a = 0; null != (i = s[a]); a++)
                            Ce(i, o[a]);
                    else
                        Ce(e, r);
                return 0 < (o = ve(r, "script")).length && Te(o, !l && ve(e, "script")),
                    o = s = i = null,
                    r
            },
            buildFragment: function (e, t, n, o) {
                for (var i, r, a, s, l, c, u, d = e.length, p = ne(t), f = [], h = 0; h < d; h++)
                    if ((r = e[h]) || 0 === r)
                        if ("object" === w.type(r))
                            w.merge(f, r.nodeType ? [r] : r);
                        else if (ue.test(r)) {
                            for (s = s || p.appendChild(t.createElement("div")),
                                l = (le.exec(r) || ["", ""])[1].toLowerCase(),
                                u = ye[l] || ye._default,
                                s.innerHTML = u[1] + r.replace(se, "<$1></$2>") + u[2],
                                i = u[0]; i--;)
                                s = s.lastChild;
                            if (!g.leadingWhitespace && ae.test(r) && f.push(t.createTextNode(ae.exec(r)[0])),
                                !g.tbody)
                                for (i = (r = "table" !== l || ce.test(r) ? "<table>" !== u[1] || ce.test(r) ? 0 : s : s.firstChild) && r.childNodes.length; i--;)
                                    w.nodeName(c = r.childNodes[i], "tbody") && !c.childNodes.length && r.removeChild(c);
                            for (w.merge(f, s.childNodes),
                                s.textContent = ""; s.firstChild;)
                                s.removeChild(s.firstChild);
                            s = p.lastChild
                        } else
                            f.push(t.createTextNode(r));
                for (s && p.removeChild(s),
                    g.appendChecked || w.grep(ve(f, "input"), be),
                    h = 0; r = f[h++];)
                    if ((!o || -1 === w.inArray(r, o)) && (a = w.contains(r.ownerDocument, r),
                        s = ve(p.appendChild(r), "script"),
                        a && Te(s),
                        n))
                        for (i = 0; r = s[i++];)
                            fe.test(r.type || "") && n.push(r);
                return s = null,
                    p
            },
            cleanData: function (e, t) {
                for (var n, o, i, r, a = 0, s = w.expando, l = w.cache, c = g.deleteExpando, u = w.event.special; null != (n = e[a]); a++)
                    if ((t || w.acceptData(n)) && (r = (i = n[s]) && l[i])) {
                        if (r.events)
                            for (o in r.events)
                                u[o] ? w.event.remove(n, o) : w.removeEvent(n, o, r.handle);
                        l[i] && (delete l[i],
                            c ? delete n[s] : typeof n.removeAttribute !== F ? n.removeAttribute(s) : n[s] = null,
                            d.push(i))
                    }
            }
        }),
        w.fn.extend({
            text: function (e) {
                return X(this, function (e) {
                    return void 0 === e ? w.text(this) : this.empty().append((this[0] && this[0].ownerDocument || _).createTextNode(e))
                }, null, e, arguments.length)
            },
            append: function () {
                return this.domManip(arguments, function (e) {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || xe(this, e).appendChild(e)
                })
            },
            prepend: function () {
                return this.domManip(arguments, function (e) {
                    var t;
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (t = xe(this, e)).insertBefore(e, t.firstChild)
                })
            },
            before: function () {
                return this.domManip(arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this)
                })
            },
            after: function () {
                return this.domManip(arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
                })
            },
            remove: function (e, t) {
                for (var n, o = e ? w.filter(e, this) : this, i = 0; null != (n = o[i]); i++)
                    t || 1 !== n.nodeType || w.cleanData(ve(n)),
                        n.parentNode && (t && w.contains(n.ownerDocument, n) && Te(ve(n, "script")),
                            n.parentNode.removeChild(n));
                return this
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) {
                    for (1 === e.nodeType && w.cleanData(ve(e, !1)); e.firstChild;)
                        e.removeChild(e.firstChild);
                    e.options && w.nodeName(e, "select") && (e.options.length = 0)
                }
                return this
            },
            clone: function (e, t) {
                return e = null != e && e,
                    t = null == t ? e : t,
                    this.map(function () {
                        return w.clone(this, e, t)
                    })
            },
            html: function (e) {
                return X(this, function (e) {
                    var t = this[0] || {}
                        , n = 0
                        , o = this.length;
                    if (void 0 === e)
                        return 1 === t.nodeType ? t.innerHTML.replace(ie, "") : void 0;
                    if (!("string" != typeof e || de.test(e) || !g.htmlSerialize && re.test(e) || !g.leadingWhitespace && ae.test(e) || ye[(le.exec(e) || ["", ""])[1].toLowerCase()])) {
                        e = e.replace(se, "<$1></$2>");
                        try {
                            for (; n < o; n++)
                                1 === (t = this[n] || {}).nodeType && (w.cleanData(ve(t, !1)),
                                    t.innerHTML = e);
                            t = 0
                        } catch (e) { }
                    }
                    t && this.empty().append(e)
                }, null, e, arguments.length)
            },
            replaceWith: function () {
                var t = arguments[0];
                return this.domManip(arguments, function (e) {
                    t = this.parentNode,
                        w.cleanData(ve(this)),
                        t && t.replaceChild(e, this)
                }),
                    t && (t.length || t.nodeType) ? this : this.remove()
            },
            detach: function (e) {
                return this.remove(e, !0)
            },
            domManip: function (n, o) {
                n = m.apply([], n);
                var e, t, i, r, a, s, l = 0, c = this.length, u = this, d = c - 1, p = n[0], f = w.isFunction(p);
                if (f || 1 < c && "string" == typeof p && !g.checkClone && pe.test(p))
                    return this.each(function (e) {
                        var t = u.eq(e);
                        f && (n[0] = p.call(this, e, t.html())),
                            t.domManip(n, o)
                    });
                if (c && (e = (s = w.buildFragment(n, this[0].ownerDocument, !1, this)).firstChild,
                    1 === s.childNodes.length && (s = e),
                    e)) {
                    for (i = (r = w.map(ve(s, "script"), we)).length; l < c; l++)
                        t = s,
                            l !== d && (t = w.clone(t, !0, !0),
                                i && w.merge(r, ve(t, "script"))),
                            o.call(this[l], t, l);
                    if (i)
                        for (a = r[r.length - 1].ownerDocument,
                            w.map(r, ke),
                            l = 0; l < i; l++)
                            t = r[l],
                                fe.test(t.type || "") && !w._data(t, "globalEval") && w.contains(a, t) && (t.src ? w._evalUrl && w._evalUrl(t.src) : w.globalEval((t.text || t.textContent || t.innerHTML || "").replace(me, "")));
                    s = e = null
                }
                return this
            }
        }),
        w.each({
            appendTo: "append",
            prependTo: "prepend",
            insertBefore: "before",
            insertAfter: "after",
            replaceAll: "replaceWith"
        }, function (e, a) {
            w.fn[e] = function (e) {
                for (var t, n = 0, o = [], i = w(e), r = i.length - 1; n <= r; n++)
                    t = n === r ? this : this.clone(!0),
                        w(i[n])[a](t),
                        s.apply(o, t.get());
                return this.pushStack(o)
            }
        });
    var _e, je, Ne = {};
    function Ee(e, t) {
        e = w(t.createElement(e)).appendTo(t.body),
            t = h.getDefaultComputedStyle ? h.getDefaultComputedStyle(e[0]).display : w.css(e[0], "display");
        return e.detach(),
            t
    }
    function Se(e) {
        var t = _
            , n = Ne[e];
        return n || ("none" !== (n = Ee(e, t)) && n || ((t = ((_e = (_e || w("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentWindow || _e[0].contentDocument).document).write(),
            t.close(),
            n = Ee(e, t),
            _e.detach()),
            Ne[e] = n),
            n
    }
    (rt = _.createElement("div")).innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",
        (Zt = rt.getElementsByTagName("a")[0]).style.cssText = "float:left;opacity:.5",
        g.opacity = /^0.5/.test(Zt.style.opacity),
        g.cssFloat = !!Zt.style.cssFloat,
        rt.style.backgroundClip = "content-box",
        rt.cloneNode(!0).style.backgroundClip = "",
        g.clearCloneStyle = "content-box" === rt.style.backgroundClip,
        Zt = rt = null,
        g.shrinkWrapBlocks = function () {
            var e, t, n;
            if (null == je) {
                if (!(e = _.getElementsByTagName("body")[0]))
                    return;
                t = _.createElement("div"),
                    n = _.createElement("div"),
                    e.appendChild(t).appendChild(n),
                    je = !1,
                    typeof n.style.zoom !== F && (n.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0;width:1px;padding:1px;zoom:1",
                        n.innerHTML = "<div></div>",
                        n.firstChild.style.width = "5px",
                        je = 3 !== n.offsetWidth),
                    e.removeChild(t),
                    e = n = null
            }
            return je
        }
        ;
    var Ae, ze, De, Le, He, qe, Fe, Me, Oe = /^margin/, Be = new RegExp("^(" + $ + ")(?!px)[a-z%]+$", "i"), Qe = /^(top|right|bottom|left)$/;
    function Pe(t, n) {
        return {
            get: function () {
                var e = t();
                if (null != e)
                    return e ? void delete this.get : (this.get = n).apply(this, arguments)
            }
        }
    }
    function We() {
        var e, t, n = _.getElementsByTagName("body")[0];
        n && (e = _.createElement("div"),
            t = _.createElement("div"),
            e.style.cssText = Me,
            n.appendChild(e).appendChild(t),
            t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;display:block;padding:1px;border:1px;width:4px;margin-top:1%;top:1%",
            w.swap(n, null != n.style.zoom ? {
                zoom: 1
            } : {}, function () {
                Le = 4 === t.offsetWidth
            }),
            Fe = !(qe = !(He = !0)),
            h.getComputedStyle && (qe = "1%" !== (h.getComputedStyle(t, null) || {}).top,
                He = "4px" === (h.getComputedStyle(t, null) || {
                    width: "4px"
                }).width),
            n.removeChild(e),
            t = n = null)
    }
    h.getComputedStyle ? (Ae = function (e) {
        return e.ownerDocument.defaultView.getComputedStyle(e, null)
    }
        ,
        ze = function (e, t, n) {
            var o, i = e.style, r = (n = n || Ae(e)) ? n.getPropertyValue(t) || n[t] : void 0;
            return n && ("" !== r || w.contains(e.ownerDocument, e) || (r = w.style(e, t)),
                Be.test(r) && Oe.test(t) && (o = i.width,
                    e = i.minWidth,
                    t = i.maxWidth,
                    i.minWidth = i.maxWidth = i.width = r,
                    r = n.width,
                    i.width = o,
                    i.minWidth = e,
                    i.maxWidth = t)),
                void 0 === r ? r : r + ""
        }
    ) : _.documentElement.currentStyle && (Ae = function (e) {
        return e.currentStyle
    }
        ,
        ze = function (e, t, n) {
            var o, i, r, a = e.style;
            return null == (r = (n = n || Ae(e)) ? n[t] : void 0) && a && a[t] && (r = a[t]),
                Be.test(r) && !Qe.test(t) && (o = a.left,
                    (n = (i = e.runtimeStyle) && i.left) && (i.left = e.currentStyle.left),
                    a.left = "fontSize" === t ? "1em" : r,
                    r = a.pixelLeft + "px",
                    a.left = o,
                    n && (i.left = n)),
                void 0 === r ? r : r + "" || "auto"
        }
    ),
        a = _.createElement("div"),
        Me = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px",
        a.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",
        (v = a.getElementsByTagName("a")[0]).style.cssText = "float:left;opacity:.5",
        g.opacity = /^0.5/.test(v.style.opacity),
        g.cssFloat = !!v.style.cssFloat,
        a.style.backgroundClip = "content-box",
        a.cloneNode(!0).style.backgroundClip = "",
        g.clearCloneStyle = "content-box" === a.style.backgroundClip,
        v = a = null,
        w.extend(g, {
            reliableHiddenOffsets: function () {
                if (null != De)
                    return De;
                var e, t, n, o = _.createElement("div"), i = _.getElementsByTagName("body")[0];
                return i ? (o.setAttribute("className", "t"),
                    o.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",
                    (e = _.createElement("div")).style.cssText = Me,
                    i.appendChild(e).appendChild(o),
                    o.innerHTML = "<table><tr><td></td><td>t</td></tr></table>",
                    (t = o.getElementsByTagName("td"))[0].style.cssText = "padding:0;margin:0;border:0;display:none",
                    n = 0 === t[0].offsetHeight,
                    t[0].style.display = "",
                    t[1].style.display = "none",
                    De = n && 0 === t[0].offsetHeight,
                    i.removeChild(e),
                    o = i = null,
                    De) : void 0
            },
            boxSizing: function () {
                return null == Le && We(),
                    Le
            },
            boxSizingReliable: function () {
                return null == He && We(),
                    He
            },
            pixelPosition: function () {
                return null == qe && We(),
                    qe
            },
            reliableMarginRight: function () {
                var e, t, n, o;
                if (null == Fe && h.getComputedStyle) {
                    if (!(e = _.getElementsByTagName("body")[0]))
                        return;
                    t = _.createElement("div"),
                        n = _.createElement("div"),
                        t.style.cssText = Me,
                        e.appendChild(t).appendChild(n),
                        (o = n.appendChild(_.createElement("div"))).style.cssText = n.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0",
                        o.style.marginRight = o.style.width = "0",
                        n.style.width = "1px",
                        Fe = !parseFloat((h.getComputedStyle(o, null) || {}).marginRight),
                        e.removeChild(t)
                }
                return Fe
            }
        }),
        w.swap = function (e, t, n, o) {
            var i, r = {};
            for (i in t)
                r[i] = e.style[i],
                    e.style[i] = t[i];
            for (i in o = n.apply(e, o || []),
                t)
                e.style[i] = r[i];
            return o
        }
        ;
    var Re = /alpha\([^)]*\)/i
        , $e = /opacity\s*=\s*([^)]*)/
        , Ie = /^(none|table(?!-c[ea]).+)/
        , Xe = new RegExp("^(" + $ + ")(.*)$", "i")
        , Ve = new RegExp("^([+-])=(" + $ + ")", "i")
        , Ue = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        }
        , Ze = {
            letterSpacing: 0,
            fontWeight: 400
        }
        , Je = ["Webkit", "O", "Moz", "ms"];
    function Ye(e, t) {
        if (t in e)
            return t;
        for (var n = t.charAt(0).toUpperCase() + t.slice(1), o = t, i = Je.length; i--;)
            if ((t = Je[i] + n) in e)
                return t;
        return o
    }
    function Ge(e, t) {
        for (var n, o, i, r = [], a = 0, s = e.length; a < s; a++)
            (o = e[a]).style && (r[a] = w._data(o, "olddisplay"),
                n = o.style.display,
                t ? (r[a] || "none" !== n || (o.style.display = ""),
                    "" === o.style.display && R(o) && (r[a] = w._data(o, "olddisplay", Se(o.nodeName)))) : r[a] || (i = R(o),
                        (n && "none" !== n || !i) && w._data(o, "olddisplay", i ? n : w.css(o, "display"))));
        for (a = 0; a < s; a++)
            (o = e[a]).style && (t && "none" !== o.style.display && "" !== o.style.display || (o.style.display = t ? r[a] || "" : "none"));
        return e
    }
    function Ke(e, t, n) {
        var o = Xe.exec(t);
        return o ? Math.max(0, o[1] - (n || 0)) + (o[2] || "px") : t
    }
    function et(e, t, n, o, i) {
        for (var r = n === (o ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; r < 4; r += 2)
            "margin" === n && (a += w.css(e, n + I[r], !0, i)),
                o ? ("content" === n && (a -= w.css(e, "padding" + I[r], !0, i)),
                    "margin" !== n && (a -= w.css(e, "border" + I[r] + "Width", !0, i))) : (a += w.css(e, "padding" + I[r], !0, i),
                        "padding" !== n && (a += w.css(e, "border" + I[r] + "Width", !0, i)));
        return a
    }
    function tt(e, t, n) {
        var o = !0
            , i = "width" === t ? e.offsetWidth : e.offsetHeight
            , r = Ae(e)
            , a = g.boxSizing() && "border-box" === w.css(e, "boxSizing", !1, r);
        if (i <= 0 || null == i) {
            if (((i = ze(e, t, r)) < 0 || null == i) && (i = e.style[t]),
                Be.test(i))
                return i;
            o = a && (g.boxSizingReliable() || i === e.style[t]),
                i = parseFloat(i) || 0
        }
        return i + et(e, t, n || (a ? "border" : "content"), o, r) + "px"
    }
    function nt(e, t, n, o, i) {
        return new nt.prototype.init(e, t, n, o, i)
    }
    w.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        e = ze(e, "opacity");
                        return "" === e ? "1" : e
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: g.cssFloat ? "cssFloat" : "styleFloat"
        },
        style: function (e, t, n, o) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i, r, a, s = w.camelCase(t), l = e.style;
                if (t = w.cssProps[s] || (w.cssProps[s] = Ye(l, s)),
                    a = w.cssHooks[t] || w.cssHooks[s],
                    void 0 === n)
                    return a && "get" in a && void 0 !== (i = a.get(e, !1, o)) ? i : l[t];
                if ("string" === (r = typeof n) && (i = Ve.exec(n)) && (n = (i[1] + 1) * i[2] + parseFloat(w.css(e, t)),
                    r = "number"),
                    null != n && n == n && ("number" !== r || w.cssNumber[s] || (n += "px"),
                        g.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                        !(a && "set" in a && void 0 === (n = a.set(e, n, o)))))
                    try {
                        l[t] = "",
                            l[t] = n
                    } catch (e) { }
            }
        },
        css: function (e, t, n, o) {
            var i, r = w.camelCase(t);
            return t = w.cssProps[r] || (w.cssProps[r] = Ye(e.style, r)),
                (r = w.cssHooks[t] || w.cssHooks[r]) && "get" in r && (i = r.get(e, !0, n)),
                void 0 === i && (i = ze(e, t, o)),
                "normal" === i && t in Ze && (i = Ze[t]),
                "" === n || n ? (t = parseFloat(i),
                    !0 === n || w.isNumeric(t) ? t || 0 : i) : i
        }
    }),
        w.each(["height", "width"], function (e, i) {
            w.cssHooks[i] = {
                get: function (e, t, n) {
                    return t ? 0 === e.offsetWidth && Ie.test(w.css(e, "display")) ? w.swap(e, Ue, function () {
                        return tt(e, i, n)
                    }) : tt(e, i, n) : void 0
                },
                set: function (e, t, n) {
                    var o = n && Ae(e);
                    return Ke(0, t, n ? et(e, i, n, g.boxSizing() && "border-box" === w.css(e, "boxSizing", !1, o), o) : 0)
                }
            }
        }),
        g.opacity || (w.cssHooks.opacity = {
            get: function (e, t) {
                return $e.test((t && e.currentStyle ? e.currentStyle : e.style).filter || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : ""
            },
            set: function (e, t) {
                var n = e.style
                    , o = e.currentStyle
                    , i = w.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : ""
                    , e = o && o.filter || n.filter || "";
                ((n.zoom = 1) <= t || "" === t) && "" === w.trim(e.replace(Re, "")) && n.removeAttribute && (n.removeAttribute("filter"),
                    "" === t || o && !o.filter) || (n.filter = Re.test(e) ? e.replace(Re, i) : e + " " + i)
            }
        }),
        w.cssHooks.marginRight = Pe(g.reliableMarginRight, function (e, t) {
            return t ? w.swap(e, {
                display: "inline-block"
            }, ze, [e, "marginRight"]) : void 0
        }),
        w.each({
            margin: "",
            padding: "",
            border: "Width"
        }, function (i, r) {
            w.cssHooks[i + r] = {
                expand: function (e) {
                    for (var t = 0, n = {}, o = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++)
                        n[i + I[t] + r] = o[t] || o[t - 2] || o[0];
                    return n
                }
            },
                Oe.test(i) || (w.cssHooks[i + r].set = Ke)
        }),
        w.fn.extend({
            css: function (e, t) {
                return X(this, function (e, t, n) {
                    var o, i, r = {}, a = 0;
                    if (w.isArray(t)) {
                        for (o = Ae(e),
                            i = t.length; a < i; a++)
                            r[t[a]] = w.css(e, t[a], !1, o);
                        return r
                    }
                    return void 0 !== n ? w.style(e, t, n) : w.css(e, t)
                }, e, t, 1 < arguments.length)
            },
            show: function () {
                return Ge(this, !0)
            },
            hide: function () {
                return Ge(this)
            },
            toggle: function (e) {
                return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
                    R(this) ? w(this).show() : w(this).hide()
                })
            }
        }),
        (w.Tween = nt).prototype = {
            constructor: nt,
            init: function (e, t, n, o, i, r) {
                this.elem = e,
                    this.prop = n,
                    this.easing = i || "swing",
                    this.options = t,
                    this.start = this.now = this.cur(),
                    this.end = o,
                    this.unit = r || (w.cssNumber[n] ? "" : "px")
            },
            cur: function () {
                var e = nt.propHooks[this.prop];
                return (e && e.get ? e : nt.propHooks._default).get(this)
            },
            run: function (e) {
                var t = nt.propHooks[this.prop];
                return this.pos = e = this.options.duration ? w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e,
                    this.now = (this.end - this.start) * e + this.start,
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    (t && t.set ? t : nt.propHooks._default).set(this),
                    this
            }
        },
        nt.prototype.init.prototype = nt.prototype,
        nt.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = w.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0 : e.elem[e.prop]
                },
                set: function (e) {
                    w.fx.step[e.prop] ? w.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[w.cssProps[e.prop]] || w.cssHooks[e.prop]) ? w.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
                }
            }
        },
        nt.propHooks.scrollTop = nt.propHooks.scrollLeft = {
            set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
            }
        },
        w.easing = {
            linear: function (e) {
                return e
            },
            swing: function (e) {
                return .5 - Math.cos(e * Math.PI) / 2
            }
        },
        w.fx = nt.prototype.init,
        w.fx.step = {};
    var ot, it, rt, at = /^(?:toggle|show|hide)$/, st = new RegExp("^(?:([+-])=|)(" + $ + ")([a-z%]*)$", "i"), lt = /queueHooks$/, ct = [function (t, e, n) {
        var o, i, r, a, s, l, c, u, d = this, p = {}, f = t.style, h = t.nodeType && R(t), m = w._data(t, "fxshow");
        for (o in n.queue || (null == (s = w._queueHooks(t, "fx")).unqueued && (s.unqueued = 0,
            l = s.empty.fire,
            s.empty.fire = function () {
                s.unqueued || l()
            }
        ),
            s.unqueued++,
            d.always(function () {
                d.always(function () {
                    s.unqueued--,
                        w.queue(t, "fx").length || s.empty.fire()
                })
            })),
            1 === t.nodeType && ("height" in e || "width" in e) && (n.overflow = [f.overflow, f.overflowX, f.overflowY],
                c = w.css(t, "display"),
                u = Se(t.nodeName),
                "none" === c && (c = u),
                "inline" === c && "none" === w.css(t, "float") && (g.inlineBlockNeedsLayout && "inline" !== u ? f.zoom = 1 : f.display = "inline-block")),
            n.overflow && (f.overflow = "hidden",
                g.shrinkWrapBlocks() || d.always(function () {
                    f.overflow = n.overflow[0],
                        f.overflowX = n.overflow[1],
                        f.overflowY = n.overflow[2]
                })),
            e)
            if (i = e[o],
                at.exec(i)) {
                if (delete e[o],
                    r = r || "toggle" === i,
                    i === (h ? "hide" : "show")) {
                    if ("show" !== i || !m || void 0 === m[o])
                        continue;
                    h = !0
                }
                p[o] = m && m[o] || w.style(t, o)
            }
        if (!w.isEmptyObject(p))
            for (o in m ? "hidden" in m && (h = m.hidden) : m = w._data(t, "fxshow", {}),
                r && (m.hidden = !h),
                h ? w(t).show() : d.done(function () {
                    w(t).hide()
                }),
                d.done(function () {
                    for (var e in w._removeData(t, "fxshow"),
                        p)
                        w.style(t, e, p[e])
                }),
                p)
                a = ft(h ? m[o] : 0, o, d),
                    o in m || (m[o] = a.start,
                        h && (a.end = a.start,
                            a.start = "width" === o || "height" === o ? 1 : 0))
    }
    ], ut = {
        "*": [function (e, t) {
            var n = this.createTween(e, t)
                , o = n.cur()
                , t = st.exec(t)
                , i = t && t[3] || (w.cssNumber[e] ? "" : "px")
                , r = (w.cssNumber[e] || "px" !== i && +o) && st.exec(w.css(n.elem, e))
                , a = 1
                , s = 20;
            if (r && r[3] !== i)
                for (i = i || r[3],
                    t = t || [],
                    r = +o || 1; a = a || ".5",
                    r /= a,
                    w.style(n.elem, e, r + i),
                    a !== (a = n.cur() / o) && 1 !== a && --s;)
                    ;
            return t && (r = n.start = +r || +o || 0,
                n.unit = i,
                n.end = t[1] ? r + (t[1] + 1) * t[2] : +t[2]),
                n
        }
        ]
    };
    function dt() {
        return setTimeout(function () {
            ot = void 0
        }),
            ot = w.now()
    }
    function pt(e, t) {
        var n, o = {
            height: e
        }, i = 0;
        for (t = t ? 1 : 0; i < 4; i += 2 - t)
            o["margin" + (n = I[i])] = o["padding" + n] = e;
        return t && (o.opacity = o.width = e),
            o
    }
    function ft(e, t, n) {
        for (var o, i = (ut[t] || []).concat(ut["*"]), r = 0, a = i.length; r < a; r++)
            if (o = i[r].call(n, t, e))
                return o
    }
    function ht(i, e, t) {
        var n, r, o = 0, a = ct.length, s = w.Deferred().always(function () {
            delete l.elem
        }), l = function () {
            if (r)
                return !1;
            for (var e = ot || dt(), e = Math.max(0, c.startTime + c.duration - e), t = 1 - (e / c.duration || 0), n = 0, o = c.tweens.length; n < o; n++)
                c.tweens[n].run(t);
            return s.notifyWith(i, [c, t, e]),
                t < 1 && o ? e : (s.resolveWith(i, [c]),
                    !1)
        }, c = s.promise({
            elem: i,
            props: w.extend({}, e),
            opts: w.extend(!0, {
                specialEasing: {}
            }, t),
            originalProperties: e,
            originalOptions: t,
            startTime: ot || dt(),
            duration: t.duration,
            tweens: [],
            createTween: function (e, t) {
                e = w.Tween(i, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                return c.tweens.push(e),
                    e
            },
            stop: function (e) {
                var t = 0
                    , n = e ? c.tweens.length : 0;
                if (r)
                    return this;
                for (r = !0; t < n; t++)
                    c.tweens[t].run(1);
                return e ? s.resolveWith(i, [c, e]) : s.rejectWith(i, [c, e]),
                    this
            }
        }), u = c.props;
        for (function (e, t) {
            var n, o, i, r, a;
            for (n in e)
                if (o = w.camelCase(n),
                    i = t[o],
                    r = e[n],
                    w.isArray(r) && (i = r[1],
                        r = e[n] = r[0]),
                    n !== o && (e[o] = r,
                        delete e[n]),
                    a = w.cssHooks[o],
                    a && "expand" in a)
                    for (n in r = a.expand(r),
                        delete e[o],
                        r)
                        n in e || (e[n] = r[n],
                            t[n] = i);
                else
                    t[o] = i
        }(u, c.opts.specialEasing); o < a; o++)
            if (n = ct[o].call(c, i, u, c.opts))
                return n;
        return w.map(u, ft, c),
            w.isFunction(c.opts.start) && c.opts.start.call(i, c),
            w.fx.timer(w.extend(l, {
                elem: i,
                anim: c,
                queue: c.opts.queue
            })),
            c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
    }
    w.Animation = w.extend(ht, {
        tweener: function (e, t) {
            for (var n, o = 0, i = (e = w.isFunction(e) ? (t = e,
                ["*"]) : e.split(" ")).length; o < i; o++)
                n = e[o],
                    ut[n] = ut[n] || [],
                    ut[n].unshift(t)
        },
        prefilter: function (e, t) {
            t ? ct.unshift(e) : ct.push(e)
        }
    }),
        w.speed = function (e, t, n) {
            var o = e && "object" == typeof e ? w.extend({}, e) : {
                complete: n || !n && t || w.isFunction(e) && e,
                duration: e,
                easing: n && t || t && !w.isFunction(t) && t
            };
            return o.duration = w.fx.off ? 0 : "number" == typeof o.duration ? o.duration : o.duration in w.fx.speeds ? w.fx.speeds[o.duration] : w.fx.speeds._default,
                null != o.queue && !0 !== o.queue || (o.queue = "fx"),
                o.old = o.complete,
                o.complete = function () {
                    w.isFunction(o.old) && o.old.call(this),
                        o.queue && w.dequeue(this, o.queue)
                }
                ,
                o
        }
        ,
        w.fn.extend({
            fadeTo: function (e, t, n, o) {
                return this.filter(R).css("opacity", 0).show().end().animate({
                    opacity: t
                }, e, n, o)
            },
            animate: function (t, e, n, o) {
                var i = w.isEmptyObject(t)
                    , r = w.speed(e, n, o)
                    , o = function () {
                        var e = ht(this, w.extend({}, t), r);
                        (i || w._data(this, "finish")) && e.stop(!0)
                    };
                return o.finish = o,
                    i || !1 === r.queue ? this.each(o) : this.queue(r.queue, o)
            },
            stop: function (i, e, r) {
                function a(e) {
                    var t = e.stop;
                    delete e.stop,
                        t(r)
                }
                return "string" != typeof i && (r = e,
                    e = i,
                    i = void 0),
                    e && !1 !== i && this.queue(i || "fx", []),
                    this.each(function () {
                        var e = !0
                            , t = null != i && i + "queueHooks"
                            , n = w.timers
                            , o = w._data(this);
                        if (t)
                            o[t] && o[t].stop && a(o[t]);
                        else
                            for (t in o)
                                o[t] && o[t].stop && lt.test(t) && a(o[t]);
                        for (t = n.length; t--;)
                            n[t].elem !== this || null != i && n[t].queue !== i || (n[t].anim.stop(r),
                                e = !1,
                                n.splice(t, 1));
                        !e && r || w.dequeue(this, i)
                    })
            },
            finish: function (a) {
                return !1 !== a && (a = a || "fx"),
                    this.each(function () {
                        var e, t = w._data(this), n = t[a + "queue"], o = t[a + "queueHooks"], i = w.timers, r = n ? n.length : 0;
                        for (t.finish = !0,
                            w.queue(this, a, []),
                            o && o.stop && o.stop.call(this, !0),
                            e = i.length; e--;)
                            i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0),
                                i.splice(e, 1));
                        for (e = 0; e < r; e++)
                            n[e] && n[e].finish && n[e].finish.call(this);
                        delete t.finish
                    })
            }
        }),
        w.each(["toggle", "show", "hide"], function (e, o) {
            var i = w.fn[o];
            w.fn[o] = function (e, t, n) {
                return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(pt(o, !0), e, t, n)
            }
        }),
        w.each({
            slideDown: pt("show"),
            slideUp: pt("hide"),
            slideToggle: pt("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function (e, o) {
            w.fn[e] = function (e, t, n) {
                return this.animate(o, e, t, n)
            }
        }),
        w.timers = [],
        w.fx.tick = function () {
            var e, t = w.timers, n = 0;
            for (ot = w.now(); n < t.length; n++)
                (e = t[n])() || t[n] !== e || t.splice(n--, 1);
            t.length || w.fx.stop(),
                ot = void 0
        }
        ,
        w.fx.timer = function (e) {
            w.timers.push(e),
                e() ? w.fx.start() : w.timers.pop()
        }
        ,
        w.fx.interval = 13,
        w.fx.start = function () {
            it = it || setInterval(w.fx.tick, w.fx.interval)
        }
        ,
        w.fx.stop = function () {
            clearInterval(it),
                it = null
        }
        ,
        w.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        },
        w.fn.delay = function (o, e) {
            return o = w.fx && w.fx.speeds[o] || o,
                e = e || "fx",
                this.queue(e, function (e, t) {
                    var n = setTimeout(e, o);
                    t.stop = function () {
                        clearTimeout(n)
                    }
                })
        }
        ,
        (rt = _.createElement("div")).setAttribute("className", "t"),
        rt.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",
        Zt = rt.getElementsByTagName("a")[0],
        v = (a = _.createElement("select")).appendChild(_.createElement("option")),
        $ = rt.getElementsByTagName("input")[0],
        Zt.style.cssText = "top:1px",
        g.getSetAttribute = "t" !== rt.className,
        g.style = /top/.test(Zt.getAttribute("style")),
        g.hrefNormalized = "/a" === Zt.getAttribute("href"),
        g.checkOn = !!$.value,
        g.optSelected = v.selected,
        g.enctype = !!_.createElement("form").enctype,
        a.disabled = !0,
        g.optDisabled = !v.disabled,
        ($ = _.createElement("input")).setAttribute("value", ""),
        g.input = "" === $.getAttribute("value"),
        $.value = "t",
        $.setAttribute("type", "radio"),
        g.radioValue = "t" === $.value,
        Zt = $ = a = rt = null;
    var mt = /\r/g;
    w.fn.extend({
        val: function (t) {
            var n, e, o, i = this[0];
            return arguments.length ? (o = w.isFunction(t),
                this.each(function (e) {
                    1 === this.nodeType && (null == (e = o ? t.call(this, e, w(this).val()) : t) ? e = "" : "number" == typeof e ? e += "" : w.isArray(e) && (e = w.map(e, function (e) {
                        return null == e ? "" : e + ""
                    })),
                        (n = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set" in n && void 0 !== n.set(this, e, "value") || (this.value = e))
                })) : i ? (n = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get" in n && void 0 !== (e = n.get(i, "value")) ? e : "string" == typeof (e = i.value) ? e.replace(mt, "") : null == e ? "" : e : void 0
        }
    }),
        w.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = w.find.attr(e, "value");
                        return null != t ? t : w.text(e)
                    }
                },
                select: {
                    get: function (e) {
                        for (var t, n = e.options, o = e.selectedIndex, i = "select-one" === e.type || o < 0, r = i ? null : [], a = i ? o + 1 : n.length, s = o < 0 ? a : i ? o : 0; s < a; s++)
                            if (!(!(t = n[s]).selected && s !== o || (g.optDisabled ? t.disabled : null !== t.getAttribute("disabled")) || t.parentNode.disabled && w.nodeName(t.parentNode, "optgroup"))) {
                                if (t = w(t).val(),
                                    i)
                                    return t;
                                r.push(t)
                            }
                        return r
                    },
                    set: function (e, t) {
                        for (var n, o, i = e.options, r = w.makeArray(t), a = i.length; a--;)
                            if (o = i[a],
                                0 <= w.inArray(w.valHooks.option.get(o), r))
                                try {
                                    o.selected = n = !0
                                } catch (e) {
                                    o.scrollHeight
                                }
                            else
                                o.selected = !1;
                        return n || (e.selectedIndex = -1),
                            i
                    }
                }
            }
        }),
        w.each(["radio", "checkbox"], function () {
            w.valHooks[this] = {
                set: function (e, t) {
                    return w.isArray(t) ? e.checked = 0 <= w.inArray(w(e).val(), t) : void 0
                }
            },
                g.checkOn || (w.valHooks[this].get = function (e) {
                    return null === e.getAttribute("value") ? "on" : e.value
                }
                )
        });
    var yt, gt, vt = w.expr.attrHandle, bt = /^(?:checked|selected)$/i, xt = g.getSetAttribute, wt = g.input;
    w.fn.extend({
        attr: function (e, t) {
            return X(this, w.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function (e) {
            return this.each(function () {
                w.removeAttr(this, e)
            })
        }
    }),
        w.extend({
            attr: function (e, t, n) {
                var o, i, r = e.nodeType;
                if (e && 3 !== r && 8 !== r && 2 !== r)
                    return typeof e.getAttribute === F ? w.prop(e, t, n) : (1 === r && w.isXMLDoc(e) || (t = t.toLowerCase(),
                        o = w.attrHooks[t] || (w.expr.match.bool.test(t) ? gt : yt)),
                        void 0 === n ? o && "get" in o && null !== (i = o.get(e, t)) ? i : null == (i = w.find.attr(e, t)) ? void 0 : i : null !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e.setAttribute(t, n + ""),
                            n) : void w.removeAttr(e, t))
            },
            removeAttr: function (e, t) {
                var n, o, i = 0, r = t && t.match(z);
                if (r && 1 === e.nodeType)
                    for (; n = r[i++];)
                        o = w.propFix[n] || n,
                            w.expr.match.bool.test(n) ? wt && xt || !bt.test(n) ? e[o] = !1 : e[w.camelCase("default-" + n)] = e[o] = !1 : w.attr(e, n, ""),
                            e.removeAttribute(xt ? n : o)
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!g.radioValue && "radio" === t && w.nodeName(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t),
                                n && (e.value = n),
                                t
                        }
                    }
                }
            }
        }),
        gt = {
            set: function (e, t, n) {
                return !1 === t ? w.removeAttr(e, n) : wt && xt || !bt.test(n) ? e.setAttribute(!xt && w.propFix[n] || n, n) : e[w.camelCase("default-" + n)] = e[n] = !0,
                    n
            }
        },
        w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var r = vt[t] || w.find.attr;
            vt[t] = wt && xt || !bt.test(t) ? function (e, t, n) {
                var o, i;
                return n || (i = vt[t],
                    vt[t] = o,
                    o = null != r(e, t, n) ? t.toLowerCase() : null,
                    vt[t] = i),
                    o
            }
                : function (e, t, n) {
                    return n ? void 0 : e[w.camelCase("default-" + t)] ? t.toLowerCase() : null
                }
        }),
        wt && xt || (w.attrHooks.value = {
            set: function (e, t, n) {
                return w.nodeName(e, "input") ? void (e.defaultValue = t) : yt && yt.set(e, t, n)
            }
        }),
        xt || (yt = {
            set: function (e, t, n) {
                var o = e.getAttributeNode(n);
                return o || e.setAttributeNode(o = e.ownerDocument.createAttribute(n)),
                    o.value = t += "",
                    "value" === n || t === e.getAttribute(n) ? t : void 0
            }
        },
            vt.id = vt.name = vt.coords = function (e, t, n) {
                return n ? void 0 : (t = e.getAttributeNode(t)) && "" !== t.value ? t.value : null
            }
            ,
            w.valHooks.button = {
                get: function (e, t) {
                    t = e.getAttributeNode(t);
                    return t && t.specified ? t.value : void 0
                },
                set: yt.set
            },
            w.attrHooks.contenteditable = {
                set: function (e, t, n) {
                    yt.set(e, "" !== t && t, n)
                }
            },
            w.each(["width", "height"], function (e, n) {
                w.attrHooks[n] = {
                    set: function (e, t) {
                        return "" === t ? (e.setAttribute(n, "auto"),
                            t) : void 0
                    }
                }
            })),
        g.style || (w.attrHooks.style = {
            get: function (e) {
                return e.style.cssText || void 0
            },
            set: function (e, t) {
                return e.style.cssText = t + ""
            }
        });
    var kt = /^(?:input|select|textarea|button|object)$/i
        , Tt = /^(?:a|area)$/i;
    w.fn.extend({
        prop: function (e, t) {
            return X(this, w.prop, e, t, 1 < arguments.length)
        },
        removeProp: function (e) {
            return e = w.propFix[e] || e,
                this.each(function () {
                    try {
                        this[e] = void 0,
                            delete this[e]
                    } catch (e) { }
                })
        }
    }),
        w.extend({
            propFix: {
                for: "htmlFor",
                class: "className"
            },
            prop: function (e, t, n) {
                var o, i, r = e.nodeType;
                if (e && 3 !== r && 8 !== r && 2 !== r)
                    return (1 !== r || !w.isXMLDoc(e)) && (t = w.propFix[t] || t,
                        i = w.propHooks[t]),
                        void 0 !== n ? i && "set" in i && void 0 !== (o = i.set(e, n, t)) ? o : e[t] = n : i && "get" in i && null !== (o = i.get(e, t)) ? o : e[t]
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = w.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : kt.test(e.nodeName) || Tt.test(e.nodeName) && e.href ? 0 : -1
                    }
                }
            }
        }),
        g.hrefNormalized || w.each(["href", "src"], function (e, t) {
            w.propHooks[t] = {
                get: function (e) {
                    return e.getAttribute(t, 4)
                }
            }
        }),
        g.optSelected || (w.propHooks.selected = {
            get: function (e) {
                e = e.parentNode;
                return e && (e.selectedIndex,
                    e.parentNode && e.parentNode.selectedIndex),
                    null
            }
        }),
        w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            w.propFix[this.toLowerCase()] = this
        }),
        g.enctype || (w.propFix.enctype = "encoding");
    var Ct = /[\t\r\n\f]/g;
    w.fn.extend({
        addClass: function (t) {
            var e, n, o, i, r, a, s = 0, l = this.length, c = "string" == typeof t && t;
            if (w.isFunction(t))
                return this.each(function (e) {
                    w(this).addClass(t.call(this, e, this.className))
                });
            if (c)
                for (e = (t || "").match(z) || []; s < l; s++)
                    if (o = 1 === (n = this[s]).nodeType && (n.className ? (" " + n.className + " ").replace(Ct, " ") : " ")) {
                        for (r = 0; i = e[r++];)
                            o.indexOf(" " + i + " ") < 0 && (o += i + " ");
                        a = w.trim(o),
                            n.className !== a && (n.className = a)
                    }
            return this
        },
        removeClass: function (t) {
            var e, n, o, i, r, a, s = 0, l = this.length, c = 0 === arguments.length || "string" == typeof t && t;
            if (w.isFunction(t))
                return this.each(function (e) {
                    w(this).removeClass(t.call(this, e, this.className))
                });
            if (c)
                for (e = (t || "").match(z) || []; s < l; s++)
                    if (o = 1 === (n = this[s]).nodeType && (n.className ? (" " + n.className + " ").replace(Ct, " ") : "")) {
                        for (r = 0; i = e[r++];)
                            for (; 0 <= o.indexOf(" " + i + " ");)
                                o = o.replace(" " + i + " ", " ");
                        a = t ? w.trim(o) : "",
                            n.className !== a && (n.className = a)
                    }
            return this
        },
        toggleClass: function (i, t) {
            var r = typeof i;
            return "boolean" == typeof t && "string" == r ? t ? this.addClass(i) : this.removeClass(i) : this.each(w.isFunction(i) ? function (e) {
                w(this).toggleClass(i.call(this, e, this.className, t), t)
            }
                : function () {
                    if ("string" == r)
                        for (var e, t = 0, n = w(this), o = i.match(z) || []; e = o[t++];)
                            n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                    else
                        r !== F && "boolean" != r || (this.className && w._data(this, "__className__", this.className),
                            this.className = !this.className && !1 !== i && w._data(this, "__className__") || "")
                }
            )
        },
        hasClass: function (e) {
            for (var t = " " + e + " ", n = 0, o = this.length; n < o; n++)
                if (1 === this[n].nodeType && 0 <= (" " + this[n].className + " ").replace(Ct, " ").indexOf(t))
                    return !0;
            return !1
        }
    }),
        w.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, n) {
            w.fn[n] = function (e, t) {
                return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n)
            }
        }),
        w.fn.extend({
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e)
            },
            bind: function (e, t, n) {
                return this.on(e, null, t, n)
            },
            unbind: function (e, t) {
                return this.off(e, null, t)
            },
            delegate: function (e, t, n, o) {
                return this.on(t, e, n, o)
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
            }
        });
    var _t = w.now()
        , jt = /\?/
        , Nt = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    w.parseJSON = function (e) {
        if (h.JSON && h.JSON.parse)
            return h.JSON.parse(e + "");
        var i, r = null, t = w.trim(e + "");
        return t && !w.trim(t.replace(Nt, function (e, t, n, o) {
            return i && t && (r = 0),
                0 === r ? e : (i = n || t,
                    r += !o - !n,
                    "")
        })) ? Function("return " + t)() : w.error("Invalid JSON: " + e)
    }
        ,
        w.parseXML = function (e) {
            var t;
            if (!e || "string" != typeof e)
                return null;
            try {
                h.DOMParser ? t = (new DOMParser).parseFromString(e, "text/xml") : ((t = new ActiveXObject("Microsoft.XMLDOM")).async = "false",
                    t.loadXML(e))
            } catch (e) {
                t = void 0
            }
            return t && t.documentElement && !t.getElementsByTagName("parsererror").length || w.error("Invalid XML: " + e),
                t
        }
        ;
    var Et, St, At = /#.*$/, zt = /([?&])_=[^&]*/, Dt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm, Lt = /^(?:GET|HEAD)$/, Ht = /^\/\//, qt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/, Ft = {}, Mt = {}, Ot = "*/".concat("*");
    try {
        St = location.href
    } catch (e) {
        (St = _.createElement("a")).href = "",
            St = St.href
    }
    function Bt(r) {
        return function (e, t) {
            "string" != typeof e && (t = e,
                e = "*");
            var n, o = 0, i = e.toLowerCase().match(z) || [];
            if (w.isFunction(t))
                for (; n = i[o++];)
                    "+" === n.charAt(0) ? (n = n.slice(1) || "*",
                        (r[n] = r[n] || []).unshift(t)) : (r[n] = r[n] || []).push(t)
        }
    }
    function Qt(t, o, i, r) {
        var a = {}
            , s = t === Mt;
        function l(e) {
            var n;
            return a[e] = !0,
                w.each(t[e] || [], function (e, t) {
                    t = t(o, i, r);
                    return "string" != typeof t || s || a[t] ? s ? !(n = t) : void 0 : (o.dataTypes.unshift(t),
                        l(t),
                        !1)
                }),
                n
        }
        return l(o.dataTypes[0]) || !a["*"] && l("*")
    }
    function Pt(e, t) {
        var n, o, i = w.ajaxSettings.flatOptions || {};
        for (o in t)
            void 0 !== t[o] && ((i[o] ? e : n = n || {})[o] = t[o]);
        return n && w.extend(!0, e, n),
            e
    }
    Et = qt.exec(St.toLowerCase()) || [],
        w.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: St,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et[1]),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": Ot,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript"
                },
                contents: {
                    xml: /xml/,
                    html: /html/,
                    json: /json/
                },
                responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON"
                },
                converters: {
                    "* text": String,
                    "text html": !0,
                    "text json": w.parseJSON,
                    "text xml": w.parseXML
                },
                flatOptions: {
                    url: !0,
                    context: !0
                }
            },
            ajaxSetup: function (e, t) {
                return t ? Pt(Pt(e, w.ajaxSettings), t) : Pt(w.ajaxSettings, e)
            },
            ajaxPrefilter: Bt(Ft),
            ajaxTransport: Bt(Mt),
            ajax: function (e, t) {
                "object" == typeof e && (t = e,
                    e = void 0),
                    t = t || {};
                var n, l, c, u, d, p, o, f = w.ajaxSetup({}, t), h = f.context || f, m = f.context && (h.nodeType || h.jquery) ? w(h) : w.event, y = w.Deferred(), g = w.Callbacks("once memory"), v = f.statusCode || {}, i = {}, r = {}, b = 0, a = "canceled", x = {
                    readyState: 0,
                    getResponseHeader: function (e) {
                        var t;
                        if (2 === b) {
                            if (!o)
                                for (o = {}; t = Dt.exec(c);)
                                    o[t[1].toLowerCase()] = t[2];
                            t = o[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    },
                    getAllResponseHeaders: function () {
                        return 2 === b ? c : null
                    },
                    setRequestHeader: function (e, t) {
                        var n = e.toLowerCase();
                        return b || (e = r[n] = r[n] || e,
                            i[e] = t),
                            this
                    },
                    overrideMimeType: function (e) {
                        return b || (f.mimeType = e),
                            this
                    },
                    statusCode: function (e) {
                        if (e)
                            if (b < 2)
                                for (var t in e)
                                    v[t] = [v[t], e[t]];
                            else
                                x.always(e[x.status]);
                        return this
                    },
                    abort: function (e) {
                        e = e || a;
                        return p && p.abort(e),
                            s(0, e),
                            this
                    }
                };
                if (y.promise(x).complete = g.add,
                    x.success = x.done,
                    x.error = x.fail,
                    f.url = ((e || f.url || St) + "").replace(At, "").replace(Ht, Et[1] + "//"),
                    f.type = t.method || t.type || f.method || f.type,
                    f.dataTypes = w.trim(f.dataType || "*").toLowerCase().match(z) || [""],
                    null == f.crossDomain && (e = qt.exec(f.url.toLowerCase()),
                        f.crossDomain = !(!e || e[1] === Et[1] && e[2] === Et[2] && (e[3] || ("http:" === e[1] ? "80" : "443")) === (Et[3] || ("http:" === Et[1] ? "80" : "443")))),
                    f.data && f.processData && "string" != typeof f.data && (f.data = w.param(f.data, f.traditional)),
                    Qt(Ft, f, t, x),
                    2 === b)
                    return x;
                for (n in (d = f.global) && 0 == w.active++ && w.event.trigger("ajaxStart"),
                    f.type = f.type.toUpperCase(),
                    f.hasContent = !Lt.test(f.type),
                    l = f.url,
                    f.hasContent || (f.data && (l = f.url += (jt.test(l) ? "&" : "?") + f.data,
                        delete f.data),
                        !1 === f.cache && (f.url = zt.test(l) ? l.replace(zt, "$1_=" + _t++) : l + (jt.test(l) ? "&" : "?") + "_=" + _t++)),
                    f.ifModified && (w.lastModified[l] && x.setRequestHeader("If-Modified-Since", w.lastModified[l]),
                        w.etag[l] && x.setRequestHeader("If-None-Match", w.etag[l])),
                    (f.data && f.hasContent && !1 !== f.contentType || t.contentType) && x.setRequestHeader("Content-Type", f.contentType),
                    x.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Ot + "; q=0.01" : "") : f.accepts["*"]),
                    f.headers)
                    x.setRequestHeader(n, f.headers[n]);
                if (f.beforeSend && (!1 === f.beforeSend.call(h, x, f) || 2 === b))
                    return x.abort();
                for (n in a = "abort",
                {
                    success: 1,
                    error: 1,
                    complete: 1
                })
                    x[n](f[n]);
                if (p = Qt(Mt, f, t, x)) {
                    x.readyState = 1,
                        d && m.trigger("ajaxSend", [x, f]),
                        f.async && 0 < f.timeout && (u = setTimeout(function () {
                            x.abort("timeout")
                        }, f.timeout));
                    try {
                        b = 1,
                            p.send(i, s)
                    } catch (e) {
                        if (!(b < 2))
                            throw e;
                        s(-1, e)
                    }
                } else
                    s(-1, "No Transport");
                function s(e, t, n, o) {
                    var i, r, a, s = t;
                    2 !== b && (b = 2,
                        u && clearTimeout(u),
                        p = void 0,
                        c = o || "",
                        x.readyState = 0 < e ? 4 : 0,
                        o = 200 <= e && e < 300 || 304 === e,
                        n && (a = function (e, t, n) {
                            for (var o, i, r, a, s = e.contents, l = e.dataTypes; "*" === l[0];)
                                l.shift(),
                                    void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                            if (i)
                                for (a in s)
                                    if (s[a] && s[a].test(i)) {
                                        l.unshift(a);
                                        break
                                    }
                            if (l[0] in n)
                                r = l[0];
                            else {
                                for (a in n) {
                                    if (!l[0] || e.converters[a + " " + l[0]]) {
                                        r = a;
                                        break
                                    }
                                    o = o || a
                                }
                                r = r || o
                            }
                            return r ? (r !== l[0] && l.unshift(r),
                                n[r]) : void 0
                        }(f, x, n)),
                        a = function (e, t, n, o) {
                            var i, r, a, s, l, c = {}, u = e.dataTypes.slice();
                            if (u[1])
                                for (a in e.converters)
                                    c[a.toLowerCase()] = e.converters[a];
                            for (r = u.shift(); r;)
                                if (e.responseFields[r] && (n[e.responseFields[r]] = t),
                                    !l && o && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                                    l = r,
                                    r = u.shift())
                                    if ("*" === r)
                                        r = l;
                                    else if ("*" !== l && l !== r) {
                                        if (!(a = c[l + " " + r] || c["* " + r]))
                                            for (i in c)
                                                if (s = i.split(" "),
                                                    s[1] === r && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                                                    !0 === a ? a = c[i] : !0 !== c[i] && (r = s[0],
                                                        u.unshift(s[1]));
                                                    break
                                                }
                                        if (!0 !== a)
                                            if (a && e.throws)
                                                t = a(t);
                                            else
                                                try {
                                                    t = a(t)
                                                } catch (e) {
                                                    return {
                                                        state: "parsererror",
                                                        error: a ? e : "No conversion from " + l + " to " + r
                                                    }
                                                }
                                    }
                            return {
                                state: "success",
                                data: t
                            }
                        }(f, a, x, o),
                        o ? (f.ifModified && ((n = x.getResponseHeader("Last-Modified")) && (w.lastModified[l] = n),
                            (n = x.getResponseHeader("etag")) && (w.etag[l] = n)),
                            204 === e || "HEAD" === f.type ? s = "nocontent" : 304 === e ? s = "notmodified" : (s = a.state,
                                i = a.data,
                                o = !(r = a.error))) : (r = s,
                                    !e && s || (s = "error",
                                        e < 0 && (e = 0))),
                        x.status = e,
                        x.statusText = (t || s) + "",
                        o ? y.resolveWith(h, [i, s, x]) : y.rejectWith(h, [x, s, r]),
                        x.statusCode(v),
                        v = void 0,
                        d && m.trigger(o ? "ajaxSuccess" : "ajaxError", [x, f, o ? i : r]),
                        g.fireWith(h, [x, s]),
                        d && (m.trigger("ajaxComplete", [x, f]),
                            --w.active || w.event.trigger("ajaxStop")))
                }
                return x
            },
            getJSON: function (e, t, n) {
                return w.get(e, t, n, "json")
            },
            getScript: function (e, t) {
                return w.get(e, void 0, t, "script")
            }
        }),
        w.each(["get", "post"], function (e, i) {
            w[i] = function (e, t, n, o) {
                return w.isFunction(t) && (o = o || n,
                    n = t,
                    t = void 0),
                    w.ajax({
                        url: e,
                        type: i,
                        dataType: o,
                        data: t,
                        success: n
                    })
            }
        }),
        w.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            w.fn[t] = function (e) {
                return this.on(t, e)
            }
        }),
        w._evalUrl = function (e) {
            return w.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                async: !1,
                global: !1,
                throws: !0
            })
        }
        ,
        w.fn.extend({
            wrapAll: function (t) {
                return w.isFunction(t) ? this.each(function (e) {
                    w(this).wrapAll(t.call(this, e))
                }) : (this[0] && (e = w(t, this[0].ownerDocument).eq(0).clone(!0),
                    this[0].parentNode && e.insertBefore(this[0]),
                    e.map(function () {
                        for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;)
                            e = e.firstChild;
                        return e
                    }).append(this)),
                    this);
                var e
            },
            wrapInner: function (n) {
                return this.each(w.isFunction(n) ? function (e) {
                    w(this).wrapInner(n.call(this, e))
                }
                    : function () {
                        var e = w(this)
                            , t = e.contents();
                        t.length ? t.wrapAll(n) : e.append(n)
                    }
                )
            },
            wrap: function (t) {
                var n = w.isFunction(t);
                return this.each(function (e) {
                    w(this).wrapAll(n ? t.call(this, e) : t)
                })
            },
            unwrap: function () {
                return this.parent().each(function () {
                    w.nodeName(this, "body") || w(this).replaceWith(this.childNodes)
                }).end()
            }
        }),
        w.expr.filters.hidden = function (e) {
            return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !g.reliableHiddenOffsets() && "none" === (e.style && e.style.display || w.css(e, "display"))
        }
        ,
        w.expr.filters.visible = function (e) {
            return !w.expr.filters.hidden(e)
        }
        ;
    var Wt = /%20/g
        , Rt = /\[\]$/
        , $t = /\r?\n/g
        , It = /^(?:submit|button|image|reset|file)$/i
        , Xt = /^(?:input|select|textarea|keygen)/i;
    w.param = function (e, t) {
        function n(e, t) {
            t = w.isFunction(t) ? t() : null == t ? "" : t,
                i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
        }
        var o, i = [];
        if (void 0 === t && (t = w.ajaxSettings && w.ajaxSettings.traditional),
            w.isArray(e) || e.jquery && !w.isPlainObject(e))
            w.each(e, function () {
                n(this.name, this.value)
            });
        else
            for (o in e)
                !function n(o, e, i, r) {
                    if (w.isArray(e))
                        w.each(e, function (e, t) {
                            i || Rt.test(o) ? r(o, t) : n(o + "[" + ("object" == typeof t ? e : "") + "]", t, i, r)
                        });
                    else if (i || "object" !== w.type(e))
                        r(o, e);
                    else
                        for (var t in e)
                            n(o + "[" + t + "]", e[t], i, r)
                }(o, e[o], t, n);
        return i.join("&").replace(Wt, "+")
    }
        ,
        w.fn.extend({
            serialize: function () {
                return w.param(this.serializeArray())
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = w.prop(this, "elements");
                    return e ? w.makeArray(e) : this
                }).filter(function () {
                    var e = this.type;
                    return this.name && !w(this).is(":disabled") && Xt.test(this.nodeName) && !It.test(e) && (this.checked || !V.test(e))
                }).map(function (e, t) {
                    var n = w(this).val();
                    return null == n ? null : w.isArray(n) ? w.map(n, function (e) {
                        return {
                            name: t.name,
                            value: e.replace($t, "\r\n")
                        }
                    }) : {
                        name: t.name,
                        value: n.replace($t, "\r\n")
                    }
                }).get()
            }
        }),
        w.ajaxSettings.xhr = void 0 !== h.ActiveXObject ? function () {
            return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && Jt() || function () {
                try {
                    return new h.ActiveXObject("Microsoft.XMLHTTP")
                } catch (e) { }
            }()
        }
            : Jt;
    var Vt = 0
        , Ut = {}
        , Zt = w.ajaxSettings.xhr();
    function Jt() {
        try {
            return new h.XMLHttpRequest
        } catch (e) { }
    }
    h.ActiveXObject && w(h).on("unload", function () {
        for (var e in Ut)
            Ut[e](void 0, !0)
    }),
        g.cors = !!Zt && "withCredentials" in Zt,
        (Zt = g.ajax = !!Zt) && w.ajaxTransport(function (l) {
            var c;
            if (!l.crossDomain || g.cors)
                return {
                    send: function (e, r) {
                        var t, a = l.xhr(), s = ++Vt;
                        if (a.open(l.type, l.url, l.async, l.username, l.password),
                            l.xhrFields)
                            for (t in l.xhrFields)
                                a[t] = l.xhrFields[t];
                        for (t in l.mimeType && a.overrideMimeType && a.overrideMimeType(l.mimeType),
                            l.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"),
                            e)
                            void 0 !== e[t] && a.setRequestHeader(t, e[t] + "");
                        a.send(l.hasContent && l.data || null),
                            c = function (e, t) {
                                var n, o, i;
                                if (c && (t || 4 === a.readyState))
                                    if (delete Ut[s],
                                        c = void 0,
                                        a.onreadystatechange = w.noop,
                                        t)
                                        4 !== a.readyState && a.abort();
                                    else {
                                        i = {},
                                            n = a.status,
                                            "string" == typeof a.responseText && (i.text = a.responseText);
                                        try {
                                            o = a.statusText
                                        } catch (e) {
                                            o = ""
                                        }
                                        n || !l.isLocal || l.crossDomain ? 1223 === n && (n = 204) : n = i.text ? 200 : 404
                                    }
                                i && r(n, o, i, a.getAllResponseHeaders())
                            }
                            ,
                            l.async ? 4 === a.readyState ? setTimeout(c) : a.onreadystatechange = Ut[s] = c : c()
                    },
                    abort: function () {
                        c && c(void 0, !0)
                    }
                }
        }),
        w.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
            },
            contents: {
                script: /(?:java|ecma)script/
            },
            converters: {
                "text script": function (e) {
                    return w.globalEval(e),
                        e
                }
            }
        }),
        w.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1),
                e.crossDomain && (e.type = "GET",
                    e.global = !1)
        }),
        w.ajaxTransport("script", function (t) {
            if (t.crossDomain) {
                var o, i = _.head || w("head")[0] || _.documentElement;
                return {
                    send: function (e, n) {
                        (o = _.createElement("script")).async = !0,
                            t.scriptCharset && (o.charset = t.scriptCharset),
                            o.src = t.url,
                            o.onload = o.onreadystatechange = function (e, t) {
                                !t && o.readyState && !/loaded|complete/.test(o.readyState) || (o.onload = o.onreadystatechange = null,
                                    o.parentNode && o.parentNode.removeChild(o),
                                    o = null,
                                    t || n(200, "success"))
                            }
                            ,
                            i.insertBefore(o, i.firstChild)
                    },
                    abort: function () {
                        o && o.onload(void 0, !0)
                    }
                }
            }
        });
    var Yt = []
        , Gt = /(=)\?(?=&|$)|\?\?/;
    w.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = Yt.pop() || w.expando + "_" + _t++;
            return this[e] = !0,
                e
        }
    }),
        w.ajaxPrefilter("json jsonp", function (e, t, n) {
            var o, i, r, a = !1 !== e.jsonp && (Gt.test(e.url) ? "url" : "string" == typeof e.data && !(e.contentType || "").indexOf("application/x-www-form-urlencoded") && Gt.test(e.data) && "data");
            return a || "jsonp" === e.dataTypes[0] ? (o = e.jsonpCallback = w.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
                a ? e[a] = e[a].replace(Gt, "$1" + o) : !1 !== e.jsonp && (e.url += (jt.test(e.url) ? "&" : "?") + e.jsonp + "=" + o),
                e.converters["script json"] = function () {
                    return r || w.error(o + " was not called"),
                        r[0]
                }
                ,
                e.dataTypes[0] = "json",
                i = h[o],
                h[o] = function () {
                    r = arguments
                }
                ,
                n.always(function () {
                    h[o] = i,
                        e[o] && (e.jsonpCallback = t.jsonpCallback,
                            Yt.push(o)),
                        r && w.isFunction(i) && i(r[0]),
                        r = i = void 0
                }),
                "script") : void 0
        }),
        w.parseHTML = function (e, t, n) {
            if (!e || "string" != typeof e)
                return null;
            "boolean" == typeof t && (n = t,
                t = !1),
                t = t || _;
            var o = x.exec(e)
                , n = !n && [];
            return o ? [t.createElement(o[1])] : (o = w.buildFragment([e], t, n),
                n && n.length && w(n).remove(),
                w.merge([], o.childNodes))
        }
        ;
    var Kt = w.fn.load;
    w.fn.load = function (e, t, n) {
        if ("string" != typeof e && Kt)
            return Kt.apply(this, arguments);
        var o, i, r, a = this, s = e.indexOf(" ");
        return 0 <= s && (o = e.slice(s, e.length),
            e = e.slice(0, s)),
            w.isFunction(t) ? (n = t,
                t = void 0) : t && "object" == typeof t && (r = "POST"),
            0 < a.length && w.ajax({
                url: e,
                type: r,
                dataType: "html",
                data: t
            }).done(function (e) {
                i = arguments,
                    a.html(o ? w("<div>").append(w.parseHTML(e)).find(o) : e)
            }).complete(n && function (e, t) {
                a.each(n, i || [e.responseText, t, e])
            }
            ),
            this
    }
        ,
        w.expr.filters.animated = function (t) {
            return w.grep(w.timers, function (e) {
                return t === e.elem
            }).length
        }
        ;
    var en = h.document.documentElement;
    function tn(e) {
        return w.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow)
    }
    w.offset = {
        setOffset: function (e, t, n) {
            var o, i, r, a, s = w.css(e, "position"), l = w(e), c = {};
            "static" === s && (e.style.position = "relative"),
                r = l.offset(),
                o = w.css(e, "top"),
                a = w.css(e, "left"),
                a = ("absolute" === s || "fixed" === s) && -1 < w.inArray("auto", [o, a]) ? (i = (s = l.position()).top,
                    s.left) : (i = parseFloat(o) || 0,
                        parseFloat(a) || 0),
                w.isFunction(t) && (t = t.call(e, n, r)),
                null != t.top && (c.top = t.top - r.top + i),
                null != t.left && (c.left = t.left - r.left + a),
                "using" in t ? t.using.call(e, c) : l.css(c)
        }
    },
        w.fn.extend({
            offset: function (t) {
                if (arguments.length)
                    return void 0 === t ? this : this.each(function (e) {
                        w.offset.setOffset(this, t, e)
                    });
                var e, n = {
                    top: 0,
                    left: 0
                }, o = this[0], i = o && o.ownerDocument;
                return i ? (e = i.documentElement,
                    w.contains(e, o) ? (typeof o.getBoundingClientRect !== F && (n = o.getBoundingClientRect()),
                        i = tn(i),
                    {
                        top: n.top + (i.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                        left: n.left + (i.pageXOffset || e.scrollLeft) - (e.clientLeft || 0)
                    }) : n) : void 0
            },
            position: function () {
                if (this[0]) {
                    var e, t, n = {
                        top: 0,
                        left: 0
                    }, o = this[0];
                    return "fixed" === w.css(o, "position") ? t = o.getBoundingClientRect() : (e = this.offsetParent(),
                        t = this.offset(),
                        w.nodeName(e[0], "html") || (n = e.offset()),
                        n.top += w.css(e[0], "borderTopWidth", !0),
                        n.left += w.css(e[0], "borderLeftWidth", !0)),
                    {
                        top: t.top - n.top - w.css(o, "marginTop", !0),
                        left: t.left - n.left - w.css(o, "marginLeft", !0)
                    }
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (var e = this.offsetParent || en; e && !w.nodeName(e, "html") && "static" === w.css(e, "position");)
                        e = e.offsetParent;
                    return e || en
                })
            }
        }),
        w.each({
            scrollLeft: "pageXOffset",
            scrollTop: "pageYOffset"
        }, function (t, i) {
            var r = /Y/.test(i);
            w.fn[t] = function (e) {
                return X(this, function (e, t, n) {
                    var o = tn(e);
                    return void 0 === n ? o ? i in o ? o[i] : o.document.documentElement[t] : e[t] : void (o ? o.scrollTo(r ? w(o).scrollLeft() : n, r ? n : w(o).scrollTop()) : e[t] = n)
                }, t, e, arguments.length, null)
            }
        }),
        w.each(["top", "left"], function (e, n) {
            w.cssHooks[n] = Pe(g.pixelPosition, function (e, t) {
                return t ? (t = ze(e, n),
                    Be.test(t) ? w(e).position()[n] + "px" : t) : void 0
            })
        }),
        w.each({
            Height: "height",
            Width: "width"
        }, function (r, a) {
            w.each({
                padding: "inner" + r,
                content: a,
                "": "outer" + r
            }, function (o, e) {
                w.fn[e] = function (e, t) {
                    var n = arguments.length && (o || "boolean" != typeof e)
                        , i = o || (!0 === e || !0 === t ? "margin" : "border");
                    return X(this, function (e, t, n) {
                        var o;
                        return w.isWindow(e) ? e.document.documentElement["client" + r] : 9 === e.nodeType ? (o = e.documentElement,
                            Math.max(e.body["scroll" + r], o["scroll" + r], e.body["offset" + r], o["offset" + r], o["client" + r])) : void 0 === n ? w.css(e, t, i) : w.style(e, t, n, i)
                    }, a, n ? e : void 0, n, null)
                }
            })
        }),
        w.fn.size = function () {
            return this.length
        }
        ,
        w.fn.andSelf = w.fn.addBack,
        "function" == typeof define && define.amd && define("jquery", [], function () {
            return w
        });
    var nn = h.jQuery
        , on = h.$;
    return w.noConflict = function (e) {
        return h.$ === w && (h.$ = on),
            e && h.jQuery === w && (h.jQuery = nn),
            w
    }
        ,
        typeof e === F && (h.jQuery = h.$ = w),
        w
});
for (var shop = "", lang_s = "", customer_email = "", customer_name = "", scripts = document.getElementsByTagName("script"), i = 0, l = scripts.length; i < l; i++)
    null != scripts[i].getAttribute("data-shop") && (shop = scripts[i].getAttribute("data-shop")),
        null == scripts[i].getAttribute("data-customer") && "" == scripts[i].getAttribute("data-customer") || (customer_email = scripts[i].getAttribute("data-customer")),
        null == scripts[i].getAttribute("data-customer-name") && "" == scripts[i].getAttribute("data-customer-name") || (customer_name = scripts[i].getAttribute("data-customer-name")),
        null != scripts[i].getAttribute("data-handle") && (product_handle = scripts[i].getAttribute("data-handle")),
        null != scripts[i].getAttribute("data-product-id") && (bisproduct_id = scripts[i].getAttribute("data-product-id"));
function ZooomyStock(e, I, X, V) {
    jQuery.ajax({
        url: "https://zooomyapps.com/backinstock/ZooomyBackinStockjson.php",
        data: {
            shop: e,
            product_id: X
        },
        dataType: "jsonp",
        jsonp: "jsonCode",
        async: "true",
        success: function (l) {
            var c = l.shop
                , u = ""
                , d = l.back_in_stock_text
                , p = l.add_font_size
                , f = l.add_border_radius
                , h = l.add_border_width
                , m = l.add_border_color
                , y = l.add_background_color
                , g = l.add_font_color
                , v = (l.back_in_stock_width,
                    l.main_heading)
                , b = l.sub_heading
                , x = l.main_heading_color
                , w = l.main_heading_size
                , k = l.sub_heading_color
                , T = l.sub_heading_size
                , C = (l.admin_email,
                    l.quantity,
                    l.notify_msg)
                , _ = l.notify_emsg
                , e = l.ccss
                , j = l.email_placeholder
                , t = l.user_added_css
                , N = l.autoemail
                , E = l.checkdata
                , S = l.shop_token
                , A = l.branding
                , z = l.tc_txt
                , D = (l.lay,
                    l.znlsignup)
                , L = l.znltxt
                , H = l.maillist;
            "" != Shopify.locale && (u = Shopify.locale);
            // console.log("看看u是什么", u);
            // 多语言适配
            let lang_code = ""
            if (u === "zh-CN") {
                lang_code = "/zh-hans";
                d = "通知我";
                b = "输入邮箱后,点击通知我,当产品有货时,我们将发送邮件通知您";
                _ = "请输入一个有效的邮箱地址";
                j = "请输入邮箱"
                C = "感谢您的订阅,当商品恢复库存时我们将通知您"
            } else if (u === "en") {
                d = "Notify me";
                b = "After entering the email, click Notify me, when the product is available, we will send an email to inform you that the stock has been replenished.";
                _ = "Please enter a valid email address";
                C = "Thank you for subscribing, we will notify you when the item is back in stock"
            } else {
                j = "請輸入郵箱"
            }
            var q, F, M, O = l.double_opt_enable, B = "", Q = "", P = "", W = "", R = "";
            "null" != V && null != V || (V = ""),
                jQuery("#zooomybackinstock").hide(),
                jQuery.ajax({
                    url: lang_code + "/products/" + I + ".js",
                    dataType: "json",
                    success: function (t) {
                        if (q = t.title,
                            F = t.price,
                            M = t.featured_image,
                            jQuery("<style>share-button.share-button{clear:both;}.product-description.rte, .product-single__description.rte{clear:both;}#zooomybackinstock #zooomyalertemail, #zooomybackinstock #zooomyalertbtn{width:100%;max-width:100%;box-sizing:border-box; margin:5px 0px;text-align:center;}.zbackinstock__headings h3{float:left;width:100%;text-align:center; font-size:" + w + "; color:" + x + ";}</style>").appendTo("body"),
                            jQuery("<style>.product-single__description.rte, .product__accordion.accordion { clear: both; }.zheading__text{float:left;width:100%;text-align:center; font-size:" + T + "; color:" + k + "}</style>").appendTo("body"),
                            jQuery("<style>#zooomyalertbtn{float:right; width:28%;padding:14px;background:" + y + "; color:" + g + ";font-size:" + p + ";border-radius:" + f + ";border:" + h + " solid " + m + ";}</style>").appendTo("body"),
                            jQuery("<style>#zooomybackinstock form{float:left;width:100%;margin:0; padding:10px 0px;}#zooomybackinstock { margin:20px 0px;float: left; width: 100%; border: 1px solid #ededed; text-align:center; padding: 20px; box-sizing: border-box; }#zooomyalertemail {padding: 14px;box-sizing: border-box; float: left; width: 70%; }</style>").appendTo("head"),
                            jQuery("<style>#zooomyalertbtn{cursor:pointer;}</style>").appendTo("body"),
                            jQuery("#zooomybackinstock").append("<div class='zbackinstock__headings'><h3>" + v + "</h3><div class='zheading__text'>" + b + "</div></div>"),
                            jQuery("#zooomybackinstock").append("<form method=''><input type='email' name='zooomyalertemail' id='zooomyalertemail' placeholder='" + j + "' value='" + V + "'/><a class='zooomybtn zooomybutton' id='zooomyalertbtn'>" + d + "</a></form>"),
                            "yes" == D && (jQuery("#zooomybackinstock form").append("<div class='zooomyneslettersignup'><div class='ZbisNewsSign'><input type='checkbox' id='zbisnl' /><label for='zbisnl'>" + L + "</label><span class='clear'></span></div></div>"),
                                jQuery("<style>.ZbisNewsSign { float: left; width: 100%; text-align: center; }input#zbisnl { height: 14px; width: 17px; min-height: 0; }.ZbisNewsSign label { display: inline; padding-left: 5px; }.ZbisNewsSign { float: left; width: 100%; text-align: center; padding: 10px 0; }</style>").appendTo("body")),
                            "yes" == A && (jQuery("#zooomybackinstock").append("<div class='zbranding' style='opacity:1!important;margin:2px 0;display:block!important;visibility:visible!important;font-weight:bold;font-size:14px!important;color:#333!important;float:left;width:100%;padding:5px 0;z-index:initial!important;margin:0!important;position:unset!important;display:block!important;'>Powered by <a style='color:#333;text-decoration:underline;display:inline!important;opacity:1!important;' href='https://apps.shopify.com/partners/zoomyapps' target='_blank'>Zooomy</a></div>"),
                                setTimeout(function () {
                                    "" === document.querySelector("#zooomybackinstock > div.zbranding").innerHTML && jQuery(".zbranding").replaceWith("<div style='opacity:1!important;margin:2px 0;visibility:visible!important;font-weight:bold;font-size:14px!important;color:#333!important;float:left;width:100%;padding:5px 0;z-index:initial!important;margin:0!important;position:unset!important;display:block!important;'>Powered by <a style='color:#333;text-decoration:underline;display:inline!important;opacity:1!important;' href='https://apps.shopify.com/partners/zoomyapps' target='_blank'>Zooomy</a></div>")
                                }, 2e3)),
                            "" != z && jQuery("#zooomybackinstock").append("<div style='font-size:12px;float:left;width:100%;padding:5px 0;'>" + z + "</div>"),
                            "yes" == l.double_opt_enable && (jQuery("<div class='zooomydoubleoptin'><input type='checkbox' id='zooomydoubleopt_Check'><label for='zooomydoubleopt_Check'>" + l.double_opt_txt + "</label><span style='clear:both'></span></div>").insertAfter("#zooomyalertbtn"),
                                jQuery("<style>#zooomyalertbtn { opacity:0.6;pointer-events:none;}</style>").appendTo("body"),
                                $("#zooomydoubleopt_Check").change(function () {
                                    O = $("input#zooomydoubleopt_Check").prop("checked") ? (jQuery("<style>#zooomyalertbtn { opacity:1;pointer-events:all;}</style>").appendTo("body"),
                                        "yes") : (jQuery("<style>#zooomyalertbtn { opacity:0.6;pointer-events:none;}</style>").appendTo("body"),
                                            "no")
                                })),
                            jQuery('form[action="/cart/add"] select#ProductSelect-product-template').addClass("zooomybisalert"),
                            jQuery('form[action="/cart/add"] .Select.Select--primary select').addClass("zooomybisalert"),
                            jQuery('form[action="/cart/add"] select.no-js-required, form[action="/cart/add"] select.no-js').addClass("zooomybisalert"),
                            jQuery('form[action="/cart/add"] input[name="id"]').addClass("zooomybisalert"),
                            jQuery('form .variant-selection select[name="id"]').addClass("zooomybisalert"),
                            jQuery('form[action="/cart/add"] select[name="id"]').addClass("zooomybisalert"),
                            0 == jQuery(".single-option-selector").length && (jQuery(".option-selectors .selector-wrapper select").addClass("single-option-selector"),
                                jQuery("form .option-select-input").addClass("single-option-selector"),
                                jQuery(".select__select").addClass("single-option-selector")),
                            0 == t.available ? jQuery("#zooomybackinstock").show() : jQuery("#zooomybackinstock").hide(),
                            t.variants.length < 2)
                            0 == t.available ? jQuery("#zooomybackinstock").show() : jQuery("#zooomybackinstock").hide(),
                                R = t.variants[0].sku;
                        else {
                            function n(e, t) {
                                for (r = 0; r < t.length; r++)
                                    if (t[r].id == e)
                                        return t[r]
                            }
                            for (var e, o = [], i = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&"), r = 0; r < i.length; r++)
                                e = i[r].split("="),
                                    o.push(e[0]),
                                    o[e[0]] = e[1];
                            var a = e[1];
                            "undefined" == (Q = function () {
                                for (var e, t = [], n = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&"), o = 0; o < n.length; o++)
                                    e = n[o].split("="),
                                        t.push(e[0]),
                                        t[e[0]] = e[1];
                                return t
                            }().variant) && (Q = a),
                                "" == Q && (Q = a),
                                "" != Q && "undefined" != Q && null != Q || ("select.zooomybisalert".length && (Q = jQuery(".zooomybisalert option:selected").val()),
                                    "" != Q && "undefined" != Q && null != Q || (Q = jQuery(".zooomybisalert").val()),
                                    "" != Q && "undefined" != Q && null != Q || (Q = $(".zooomybisalert").find("option:first-child").val())),
                                null != Q && (getvariantid = n(Q, t.variants),
                                    getvariantid && (0 == getvariantid.available && (jQuery("#zooomybackinstock").show(),
                                        P = getvariantid.title,
                                        null != getvariantid.featured_image && (W = getvariantid.featured_image.src),
                                        "" != R && null != R && null != R || (R = getvariantid.sku)),
                                        1 == getvariantid.available && jQuery("#zooomybackinstock").hide())),
                                changefunction = ".single-option-selector",
                                changeaction = "change",
                                "mini-mudders.myshopify.com" == c && (changefunction = ".product-single__variants"),
                                "ursul-paris.myshopify.com" == c && (changefunction = ".product-variant.selector-wrapper",
                                    changeaction = "click"),
                                jQuery('form[action="/cart/add"]  input[type="radio"]').length && (changefunction = 'form[action="/cart/add"]  input[type="radio"]'),
                                jQuery('.no-js-hidden .product-form__input input[type="radio"]').length && (changefunction = 'fieldset.product-form__input input[type="radio"]',
                                    changeaction = "change"),
                                jQuery('.variant-wrapper input[type="radio"]').length && (changefunction = '.variant-wrapper input[type="radio"]',
                                    changeaction = "change"),
                                jQuery('.option-selector__btns input[type="radio"]').length && (changefunction = '.option-selector__btns input[type="radio"]',
                                    changeaction = "change"),
                                jQuery('.ProductForm__Variants input[type="radio"]').length && (changefunction = '.ProductForm__Variants  input[type="radio"]',
                                    changeaction = "change"),
                                jQuery('.product-form input[type="radio"]').length && (changefunction = '.product-form input[type="radio"]',
                                    changeaction = "change"),
                                jQuery('form .swatch__options input[type="radio"]').length && (changefunction = 'form .swatch__options input[type="radio"]'),
                                jQuery(".product__details .product__controls-group button").length && (changefunction = ".product__details .product__controls-group button",
                                    changeaction = "click"),
                                jQuery(".variant-swatch-king .swatch-selector").length && (changefunction = ".variant-swatch-king .swatch-selector",
                                    changeaction = "change"),
                                jQuery('.selector-wrapper input[type="radio"]').length && (changefunction = '.selector-wrapper input[type="radio"]'),
                                jQuery('form[action="/cart/add"]  .single-option-selector').length && (changefunction = 'form[action="/cart/add"]  .single-option-selector'),
                                jQuery('.product-single__box variant-radios  input[type="radio"]').length && (changefunction = '.product-single__box variant-radios  input[type="radio"]'),
                                jQuery('.variant-wrapper input[type="radio"]').length && jQuery(".variant-wrapper .single-option-selector").length && (changefunction = '.variant-wrapper input[type="radio"], .variant-wrapper .single-option-selector',
                                    changeaction = "change"),
                                jQuery(".ProductForm__Option #Block-variant_picker .Form__Select.single-option-selector").length && (changefunction = ".ProductForm__Option #Block-variant_picker .Form__Select.single-option-selector",
                                    changeaction = "change"),
                                jQuery(changefunction).on(changeaction, function () {
                                    setTimeout(function () {
                                        var e;
                                        0 < "select.zooomybisalert".length && (Q = jQuery(".zooomybisalert option:selected").val(),
                                            e = jQuery(".zooomybisalert option:selected").text(),
                                            P = e.trim()),
                                            "" != Q && "undefined" != Q && null != Q || (Q = jQuery(".zooomybisalert").val()),
                                            "" != Q && "undefined" != Q && null != Q || (Q = jQuery("input[name=id]").val()),
                                            "" == Q && (Q = function () {
                                                for (var e, t = [], n = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&"), o = 0; o < n.length; o++)
                                                    e = n[o].split("="),
                                                        t.push(e[0]),
                                                        t[e[0]] = e[1];
                                                return t
                                            }().variant),
                                            "undefined" == Q && (Q = a),
                                            "" == Q && (Q = a),
                                            null != Q && (getvariantid = n(Q, t.variants),
                                                getvariantid && (0 == getvariantid.available && (jQuery("#zooomybackinstock").show(),
                                                    "" != P && null != P && null != P || (P = getvariantid.title),
                                                    null != getvariantid.featured_image && ("" != W && null != W && null != W || (W = getvariantid.featured_image.src)),
                                                    "" != R && null != R && null != R || (R = getvariantid.sku)),
                                                    1 == getvariantid.available && jQuery("#zooomybackinstock").hide()))
                                    }, 250)
                                })
                        }
                        if ("" == Q && (Q = ""),
                            jQuery("#zooomyalertbtn").click(function () {
                                jQuery("p.zooomystockmsg").replaceWith("<p></p>"),
                                    "yes" == D && document.getElementById("zbisnl").checked && (B = "yes");
                                var e = jQuery("#zooomyalertemail").val();
                                jQuery.ajax({
                                    url: "https://zooomyapps.com/backinstock/zooomybackinstock.php",
                                    data: {
                                        vsku: R,
                                        znlcheck: B,
                                        double_opt: O,
                                        shop: c,
                                        product_id: X,
                                        product_handle: I,
                                        customer_name: customer_name,
                                        customer_email: V,
                                        variant_id: Q,
                                        title: q,
                                        img: M,
                                        price: F,
                                        vtitle: P,
                                        zooomyalertemail: e,
                                        variant_img: W,
                                        lang_s: u
                                    },
                                    dataType: "jsonp",
                                    jsonp: "ZooomyGetDataPage",
                                    async: "true",
                                    success: function (e) {
                                        var t = e.already_added;
                                        jQuery('#zooomybackinstock input[type="email"]').val(""),
                                            "Valid" == e.emailcheck && jQuery("#zooomybackinstock").append("<p class='zooomystockmsg'>" + C + "</p>"),
                                            "Invalid" == e.emailcheck && jQuery("#zooomybackinstock").append("<p  class='zooomystockmsg'>" + _ + "</p>"),
                                            "" == t || null == t || jQuery("#zooomybackinstock").append("<p  class='zooomystockmsg'>" + e.already_added + "</p>")
                                    }
                                }),
                                    "yes" == H && (e = jQuery("#zooomyalertemail").val(),
                                        jQuery.ajax({
                                            url: "https://zooomyapps.com/backinstock/klaviyo/ZooomyFrontendAjax.php",
                                            data: {
                                                znlcheck: B,
                                                customer_email: e,
                                                customer_name: customer_name,
                                                shop: c,
                                                product_title: q
                                            },
                                            dataType: "jsonp",
                                            jsonp: "ZooomyGetMail",
                                            async: "true",
                                            success: function (e) { }
                                        }))
                            }),
                            document.addEventListener("keypress", e => {
                                if ("zooomyalertemail" === e.target.id && 13 === e.keyCode) {
                                    e.target;
                                    e.preventDefault(),
                                        e.stopPropagation();
                                    const t = document.getElementById("zooomyalertbtn");
                                    t && t.click()
                                }
                            }
                            ),
                            "yes" == N && 0 < E) {
                            for (var s = [], r = 0; r < t.variants.length; r++)
                                1 == t.variants[r].available && (valv = t.variants[r].id,
                                    s.push(valv));
                            0 === s.length || jQuery.ajax({
                                url: "https://zooomyapps.com/backinstock/send-mail/zooomy_email_check.php",
                                data: {
                                    shop: c,
                                    product_id: X,
                                    product_handle: I,
                                    variant_id: s,
                                    title: q,
                                    img: M,
                                    shop_token: S,
                                    lang_s: u
                                },
                                dataType: "jsonp",
                                jsonp: "ZooomyAutoEmail",
                                async: "true",
                                success: function (e) { }
                            })
                        }
                    }
                }),
                jQuery("<style>#zooomybackinstock > div{display:block!important;}</style>").appendTo("body"),
                jQuery("<style>" + e + "</style>").appendTo("body"),
                jQuery("<style>" + t + "</style>").appendTo("body")
        }
    })
}
shop = Shopify.shop,
    product_id = meta.product.id,
    "" != product_id && null != product_id && null != product_id || (product_id = bisproduct_id),
    ZooomyStock(shop, product_handle, product_id, customer_email);
